
import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useRef
} from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, Link as RouterLink, NavLink, useNavigate, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf'; 
import { jsPDF as JsPDF } from 'jspdf'; 
import { toWords } from 'number-to-words';
import { log } from '@linways/table-to-excel';
import { Button, Typography, Modal } from '@mui/material';
import storeConfig from "../../store";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
import * as masterAction from "../../actions/masterAction";
import * as reportActions from "../../actions/reportActions";
import LeadChecklists from "../lead/LeadChecklists";
import LeadQuestionnaire from "../lead/LeadQuestionnaire";
import FiDetils from "../lead/FiDetils";




const LoanVersioning = forwardRef ((props,ref) => {
  const { vitem, actions } = props;
  
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();

  const [allEMIsArr, setAllEMIsArr] = useState([]);
  const [allModifiedEMIsArr, setAllModifiedEMIsArr] = useState([]);

  const [activeTabName, setActiveTabName] = useState('schedule');
  const [loanDetailsArr, setLoanDetailsArr] = useState([]);
  const [loanDetailsModifiedArr, setLoanDetailsModifiedArr] = useState([]);
  const [additionalMissingData, setAdditionalMissingData] = useState([]);

  // Due Reminder Notice states
  const [dueReminderActiveTab, setDueReminderActiveTab] = useState('applicant');
  const [dueReminderDownloadHistory, setDueReminderDownloadHistory] = useState({});
  const [dueReminderPreloader, setDueReminderPreloader] = useState(false);
  const [dueReminderSubTabs, setDueReminderSubTabs] = useState([]);
  
  const [ preloaderStatus, setPreloaderStatus] = useState(false);
  const [allUploadLeadDocument, setAllUploadLeadDocument] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [leadID, setLeadID] = useState('');
  const [showLeadDetails, setShowLeadDetails] = useState(false);
  const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);

   const [openQue, setOpenQue] = useState(false);
  const [userRoleType, setUserRoleType] = useState("User");
  const [creditAllLeadCheckLists, setCreditAllLeadCheckLists] = useState([]);
  const [leadStatusFlag, setLeadStatusFlag] = useState(false);
  const [camLatestStatus, setCamLatestStatus] = useState("");
  const [questions, setQuestions] = useState([]);
  const [scoreCard, setScoreCard] = useState("");
  const [allFiSaveHistory, setAllFiSaveHistory] = useState([]);

 const [refNo, setRefNo] = useState('');
 const [refDate, setRefDate] = useState('');
 const [regionalTransportAuthority, setRegionalTransportAuthority] = useState('');
 const [vehicleNo, setVehicleNo] = useState('');
 const [ownerName, setOwnerName] = useState('');
 const [showSanctionNote, setShowSanctionNote] = useState('');
 const [sanctionApproveLatestStatus, setSanctionApproveLatestStatus] = useState(0);
 const [sanctionApproveAndSendMailLatestStatus, setSanctionApproveAndSendMailLatestStatus] = useState(0);
 const [isReadyToModify, setIsReadyToModify] = useState(true); 
 const [savedApplicationDetailsInfo, setSavedApplicationDetailsInfo] = useState([]); 
 
 const [latestDownloadedByName, setLatestDownloadedByName] = useState(''); 
 const [latestDownloadedDateFormat, setLatestDownloadedDateFormat] = useState('');

  
 const [enableUpdatePdfDetails, setEnableUpdatePdfDetails] = useState(false); 
 const [applicationDetailsFormActiveTab, setApplicationDetailsFormActiveTab] = useState('noObjectionCertificate');
 const [approveBtnAction, setApproveBtnAction] = useState(0);
 const [sendEmailBtnAction, setSendEmailBtnAction] = useState(0);
 const [openRejectAmt, setOpenRejectAmt] = useState(false);

 const [ allLmsCoApplicants , setAllLmsCoApplicants] = useState([]);
 const [allLmsGuarantors , setAllLmsGuarantors] = useState([]);
 const [phoneHistory, setPhoneHistory] = useState(null);
 const [phoneHistoryLoader, setPhoneHistoryLoader] = useState(false);

  const [formValues, setFormValues] = useState({
    priority_type: '',
    type_topic: '',
    residence_status: '',
    profile: '',
    msme: '',
    stability: '',
    sector_of_unit: '',
    sub_sector: '',
    business_of_occupation: '',
    turnover: '',
    dl_number: '',
    dl_status: '',
    category: '',
    region: '',
    city_stability: '',
    residence_stability: '',
    business_stability: '',
    driving_experience: '',
    product: '',
    relation_with_applicant: '',
    battery_number: '',
    deployment_of_asset: '',
    warranty_detail: '',
  });

  const navigate = useNavigate();
  useEffect(() => {
      // check user is logged-in or not
      const authToken = localStorage.getItem("authToken");
      const roleName = localStorage.getItem('authUserRoleName'); 
      if (authToken === null) {
        navigate("/login");
      }
   
       if (roleName !== undefined ) {
            setUserRoleType(roleName);
        } 
   
    }, [setUserRoleType]);
 
    const state = storeConfig.store.getState();

    const loggedInUserId = state?.userInfo?.id || '';

    console.log("LOGGED IN USER ID =", loggedInUserId);

  const fetchPaymentLoanDocuments = useCallback(() => { 
                 const obj = { 'start': '0', 'length': config.MAX_RECORDS, "AgreementNo": vitem.AgreementNo };
                 // console.log("obj lead id- ", obj);
                 const requestData = encryptData(obj);
                 const response = actions.getUploadLoanPaymentData(requestData);
     
                 response.then((result) => { 
                     // console.log("Promise resolved -  source data:", result); 
                     if (result.data.success === 1) {
                         const results = result.data.data.data;
                         const resultArr = Object.keys(results).map((key) => results[key]);
                         setAllUploadLeadDocument(resultArr);
                     }
                 }).catch((error) => {
                     //  console.error("Promise rejected -  source data :", error); 
                 });
              
  },[]);

  const backToPhoneHistoryHandler = () => {
    setActiveTabName('phone_history');
    fetchPhoneHistory();
};

const fetchPhoneHistory = useCallback(async () => {

    if (!vitem?.AgreementNo) return;

    setPhoneHistoryLoader(true);

    try {

        const obj = {
            AgreementNo: vitem.AgreementNo
        };

        const requestData = encryptData(obj);

        const response = await fetch(
            `${config.API_BASE_URL}get_phone_scrub_history`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: requestData
            }
        );

        const result = await response.json();

        console.log("Agreement =", vitem.AgreementNo);
        console.log("Phone History =", result);

        if (result?.success === 1) {
            setPhoneHistory(result.data || null);
        } else {
            setPhoneHistory(null);
        }

    } catch (err) {

        console.error("PHONE HISTORY ERROR =", err);
        setPhoneHistory(null);

    } finally {

        setPhoneHistoryLoader(false);

    }

}, [vitem]);

useEffect(() => {

    if (activeTabName === "point_of_interest") {
        fetchPOIData(1);
    }

}, [activeTabName]);

const fetchPOIData = useCallback(async (page = 1) => {

    try {

        const obj = {
            AgreementNo: vitem.AgreementNo,
            page,
            limit: 10
        };

        const requestData = encryptData(obj);

        const response = await fetch(
            `${config.API_BASE_URL}get_poi_data`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: requestData
            }
        );

        const result = await response.json();

        if (result?.success === 1) {

            // setLatestLocation(
            //     result.data.latest_location || {}
            // );
            setLatestLocation(
              result.data.latest_location || {}
          );

            setRawHistoryData(
                result.data.raw_history || []
            );

            setMultiVisitData(
                result.data.multi_visit || []
            );

            setHomeBaseData(
                result.data.home_base || []
            );

            setPoiPagination(
                result.data.pagination || {}
            );
        }

    } catch (err) {

        console.error(err);

    }

}, [vitem]);

const [poiLoader, setPoiLoader] = useState(false);

const checkCurrentLocation = useCallback(async () => {

    if (!vitem?.AgreementNo) return;

    setPoiLoader(true);

    try {

        const obj = {
            AgreementNo: vitem.AgreementNo,
            created_by: loggedInUserId,
            updated_by: loggedInUserId
        };

        const requestData = encryptData(obj);

        const response = await fetch(
            `${config.API_BASE_URL}fetch_poi_data`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: requestData
            }
        );

        const result = await response.json();

        console.log("POI REQUEST =", obj);
        console.log("POI RESPONSE =", result);

        if (result?.success === 1) {

            toast.success(result.message);

            fetchPOIData();

        } else {

            toast.error(result.message || "Something went wrong");

        }

    } catch (err) {

        console.error("POI ERROR =", err);

        toast.error("Unable to fetch POI data");

    } finally {

        setPoiLoader(false);

    }

}, [vitem, loggedInUserId]);

useImperativeHandle(ref, () => ({
    runPOIFlow: async () => {

        await fetchPOIData(1);

    },

    fetchPOIData,
    fetchPaymentLoanDocuments
}));

const KmRunHistoryByAgreement = ({ agreementNo }) => {
    const [tableData, setTableData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        if (!agreementNo) return;

        const fetchData = async () => {
            try {
                setLoading(true);
                const obj = { agreement_number: agreementNo };
                const requestData = encryptData(obj);
                const response = await fetch(
                    `${config.API_BASE_URL}get-km-run-history-by-agreement`,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: requestData
                    }
                );
                const result = await response.json();
                setLoading(false);
                if (result?.success === 1) {
                    setTableData(result.data || []);
                }
            } catch (err) {
                setLoading(false);
                console.error(err);
            }
        };

        fetchData();
    }, [agreementNo]);

    return (
        <div className="card shadow-sm border-0">
            <div className="card-body">
                <h5 className="mb-3">KM Run History</h5>
                <div className="table-wrap table-responsive">
                    <table className="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>Agreement Number</th>
                                <th>Chassis Number</th>
                                <th>OEM</th>
                                <th>First Timestamp</th>
                                <th>Last Timestamp</th>
                                <th>Start Odometer</th>
                                <th>End Odometer</th>
                                <th>Run KM</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={8} className="text-center">Loading...</td></tr>
                            ) : tableData.length === 0 ? (
                                <tr><td colSpan={8} className="text-center">No data available</td></tr>
                            ) : (
                                tableData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.agreement_number}</td>
                                        <td>{item.chassis_number}</td>
                                        <td>{item.oem}</td>
                                        <td>
                                          {item.first_timestamp
                                            ? `${String(new Date(item.first_timestamp).getDate()).padStart(2, "0")}-${String(new Date(item.first_timestamp).getMonth() + 1).padStart(2, "0")}-${String(new Date(item.first_timestamp).getFullYear()).slice(-2)} ${String(new Date(item.first_timestamp).getHours()).padStart(2, "0")}:${String(new Date(item.first_timestamp).getMinutes()).padStart(2, "0")}:${String(new Date(item.first_timestamp).getSeconds()).padStart(2, "0")}`
                                            : "-"}
                                        </td>

                                        <td>
                                          {item.last_timestamp
                                            ? `${String(new Date(item.last_timestamp).getDate()).padStart(2, "0")}-${String(new Date(item.last_timestamp).getMonth() + 1).padStart(2, "0")}-${String(new Date(item.last_timestamp).getFullYear()).slice(-2)} ${String(new Date(item.last_timestamp).getHours()).padStart(2, "0")}:${String(new Date(item.last_timestamp).getMinutes()).padStart(2, "0")}:${String(new Date(item.last_timestamp).getSeconds()).padStart(2, "0")}`
                                            : "-"}
                                        </td>

                                        <td>{item.start_odometer}</td>
                                        <td>{item.end_odometer}</td>
                                        <td>{item.run_km}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

  const fetchLeads = useCallback((id = '') => { 
 
      setShowLeadDetails(false);
       if ( !showLeadDetails) {
                const obj = {
                        start: "0",
                        length: config.MAX_RECORDS,
                        lead_id: id,
                        "api_calling_module": "vehicle_inspection_form",
                        "AgreementNo":vitem.AgreementNo
                      };
                 // console.log("obj lead id- ", obj);
                 const requestData = encryptData(obj);
                 const response = actions.leadInfo(requestData);
     
                 response.then((result) => { 
                     // console.log("Promise resolved -  source data:", result); 
                     if (result.data.success === 1) {
                        //  alert('success');
                           const leadInfoData = result.data.data;
                              if ("data" in leadInfoData && leadInfoData.data.length > 0) {
                                setShowLeadDetails(true); 

                                 // get lead assigned checklists
                                const results = leadInfoData.data[0].all_checklists || [];
                                const resultChecklistArr = Object.keys(results).map(
                                  (key) => results[key]
                                );
                                setAllLeadCheckLists(resultChecklistArr);

                                const fiSaveHistory = leadInfoData.data[0].fiSaveHistory || [];
                                setAllFiSaveHistory(fiSaveHistory);

                                 const creditCheckListsResults =
                                  leadInfoData.data[0].credit_all_checklists || [];
                                const creditCheckListsResultsArr = Object.keys(
                                  creditCheckListsResults
                                ).map((key) => creditCheckListsResults[key]);
                                setCreditAllLeadCheckLists(creditCheckListsResultsArr);

                                if (
                                  Object.prototype.hasOwnProperty.call(
                                    leadInfoData.data[0],
                                    "statusName"
                                  )
                                ) {
                                  const statusName = leadInfoData.data[0].statusName;

                                  if (statusName === "CLOSED") {
                                    setLeadStatusFlag(true);
                                  } else {
                                    setLeadStatusFlag(false);
                                  }
                                }

                                if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0],"camLatestStatus") &&
                                  leadInfoData.data[0].camLatestStatus !== "") {
                                      setCamLatestStatus(leadInfoData.data[0].camLatestStatus);
                                }
                                                  
                              }

                              
                     }
                 }).catch((error) => {
                     //  console.error("Promise rejected -  source data :", error); 
                 });
              }
              
  },[]);

  const updateParentState = (newValue) => {
     fetchLeads(leadID);
  };

  const onRowClickActionWL = (itemObj, btnAction) => {
        console.log("itemObj = ", itemObj);

        if (userRoleType === "Credit") {
          //  setQuestions(itemObj.credit_questions_data_decoded);
            setQuestions(itemObj.questions_data_decoded);
        } else {
            setQuestions(itemObj.questions_data_decoded);
        }
        setViewModalInfo(itemObj);
        setOpen(true);
    };

  // Handler for EMIs Schedule tab
  const backToScheduleHandler = () => {
    setActiveTabName('schedule');
  };

  // Handler for Additional Data tab
  const backToAdditionalHandler = () => {
    setActiveTabName('additional');
  };

  const backToPaymentDocumentsHandler = () => {
    setActiveTabName('payment_documents');
    fetchPaymentLoanDocuments();
  };

   const backToVehicleInspectionFormHandler = () => {
    setActiveTabName('vehicle_inspection_form');

     fetchLeads(leadID);
  }; 

  const backToLegalActionsHandler = () => {
    setActiveTabName('legal_actions');

     fetchLeads(leadID);
  };

  const backToNoObjectionCertificateHandler = () => {
    setActiveTabName('no_objection_certificate');

     fetchLeads(leadID);
  };

  const backToDueReminderNoticeHandler = () => {
    setActiveTabName('due_reminder_notice');
    // Reset to applicant tab when switching to Due Reminder Notice
    setDueReminderActiveTab('applicant');
    // Note: Download history will be fetched in useEffect when tab becomes active
  };

  // Due Reminder Notice: Fetch existing download history for all borrowers
  const fetchDueReminderDownloadHistory = useCallback(() => {
    if (vitem?.AgreementNo && vitem?.lstCoBorrowers && Array.isArray(vitem.lstCoBorrowers)) {
      console.log("Fetching Due Reminder download history for agreement:", vitem.AgreementNo);

      // Fetch download history for each borrower
      vitem.lstCoBorrowers.forEach((borrower) => {
        let borrowerType = '';

        // Determine borrower type
        if (borrower.EntityTypeId === "Customer" && borrower.OrderTypeId === "Primary") {
          borrowerType = 'applicant';
        } else if (borrower.EntityTypeId === "Customer" && borrower.OrderTypeId === "Secondary") {
          borrowerType = 'co-applicant';
        } else if (borrower.EntityTypeId === "Guarantor" && borrower.OrderTypeId === "Primary") {
          borrowerType = 'guarantor';

         } else if (borrower.EntityTypeId === "Guarantor" && borrower.OrderTypeId === "Secondary") {
          borrowerType = 'guarantor';  
        }

        if (borrowerType) {
          const obj = {
            "AgreementNo": vitem.AgreementNo,
            "borrowerType": borrowerType,
            "borrowerId": borrower.CustomerId,
            "start": 0,
            "length": 1
          };

          const requestData = encryptData(obj);
          const response = actions.getDueReminderDownloadHistory(requestData);

          response.then((result) => {
            if (result.data.success === 1 && result.data.data?.data?.length > 0) {
              const latestDownload = result.data.data.data[0];
              console.log(`Latest download for ${borrowerType}-${borrower.CustomerId}:`, latestDownload);

              // Update download history state
              setDueReminderDownloadHistory(prev => ({
                ...prev,
                [`${borrowerType}-${borrower.CustomerId}`]: {
                  downloadedBy: latestDownload.downloadedByName || '',
                  downloadedDate: latestDownload.downloadedDateFormat || ''
                }
              }));
            }
          }).catch((error) => {
            console.error(`Error fetching download history for ${borrowerType}-${borrower.CustomerId}:`, error);
          });
        }
      });
    }
  }, [vitem, actions]);

  useEffect(() => {
    setLeadID('');
    console.log("vitem = ",vitem);


      if (vitem && Object.prototype.hasOwnProperty.call(vitem, 'all_co_applicants')) {
          const allLmsCoApplicantsArr = vitem?.all_co_applicants || [];
          setAllLmsCoApplicants(allLmsCoApplicantsArr);
      }

      if (vitem && Object.prototype.hasOwnProperty.call(vitem, 'all_guarantors')) {
          const allLmsGuarantorsArr = vitem?.all_guarantors || [];
          setAllLmsGuarantors(allLmsGuarantorsArr);
      }
 

     if (vitem && Object.prototype.hasOwnProperty.call(vitem, 'linkedLeadDetails')) {
        if (vitem.linkedLeadDetails && Object.prototype.hasOwnProperty.call(vitem.linkedLeadDetails, 'id')) {
          const id = vitem.linkedLeadDetails?.id;
          setLeadID(id);
          console.log("LeadID = ", id);
          fetchLeads(id);   // pass it directly
        }
    }

    if (vitem && Object.prototype.hasOwnProperty.call(vitem, 'RepaymentSchedules')) {
      setAllEMIsArr(vitem.RepaymentSchedules);
    }

    if (vitem && Object.prototype.hasOwnProperty.call(vitem, 'comparedEmisDetails')) {

      const comparedEmisDetails = vitem.comparedEmisDetails;
      if (comparedEmisDetails && Object.prototype.hasOwnProperty.call(comparedEmisDetails, 'modifiedJSONInfo')) {
        setAllModifiedEMIsArr(comparedEmisDetails.modifiedJSONInfo);

        console.log("comparedEmisDetails.modifiedJSONInfo = ", comparedEmisDetails.modifiedJSONInfo);
      }
    }

    if (vitem && Object.prototype.hasOwnProperty.call(vitem, 'loanDetails')) {
      setLoanDetailsArr(vitem.loanDetails);
    }

    if (vitem && Object.prototype.hasOwnProperty.call(vitem, 'compareLoanDetails')) {
      const compareLoanDetails = vitem.compareLoanDetails;
      setLoanDetailsModifiedArr(compareLoanDetails);
    }

    if (vitem && Object.prototype.hasOwnProperty.call(vitem, 'additionalMissingData')) {
      setAdditionalMissingData(vitem.additionalMissingData);
    }
 
    setOwnerName(vitem?.CustomerName || '');

    setVehicleNo( vitem?.recordsVehicle?.[0]?.RegistrationNo || '' );

     const applicationDetailsInfo = vitem?.latestApplicationDetailsRowInfo;
      setSavedApplicationDetailsInfo(applicationDetailsInfo); 


       
      if(applicationDetailsInfo !== null ){ 
          console.log("111111111 applicationDetailsInfo?.vitem = ", applicationDetailsInfo);

          setLatestDownloadedByName(applicationDetailsInfo?.latestDownloadedByName || ''); 
          setLatestDownloadedDateFormat(applicationDetailsInfo?.latestDownloadedDateFormat || '');
          
        if(applicationDetailsInfo?.additionalDetails){
            console.log("222222 applicationDetailsInfo?.vitem = ", applicationDetailsInfo?.additionalDetails);
            const parsedData = JSON.parse(applicationDetailsInfo?.additionalDetails);
            setRefNo(parsedData.refNo);

            
            if (parsedData.refDate && parsedData.refDate !== '0000-00-00') {
              const date = new Date(parsedData.refDate);

              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();

              const formattedDate = `${day}-${month}-${year}`;

              setRefDate(formattedDate);
          }
            setRegionalTransportAuthority(parsedData.regionalTransportAuthority);
        }
      }
 
     
    // Generate Due Reminder Notice sub-tabs when vitem changes
    if (vitem?._isDueReminderNoticeEnabled ) {
      console.log("useEffect: vitem._isDueReminderNoticeEnabled =", vitem._isDueReminderNoticeEnabled);
      console.log("useEffect: vitem.lstCoBorrowers =", vitem.lstCoBorrowers);
      const subTabs = generateDueReminderSubTabs();
      setDueReminderSubTabs(subTabs);

      // Fetch existing download history for all borrowers
      fetchDueReminderDownloadHistory();
    }

    fetchPaymentLoanDocuments();

  }, [setAllEMIsArr, setAllModifiedEMIsArr, setLoanDetailsArr, setLoanDetailsModifiedArr, setAdditionalMissingData,setLeadID, vitem, fetchDueReminderDownloadHistory]);

  const formatDate = (date) => {
    if (date === null || date === '' || date === undefined) {
      return '';
    }

    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const day = String(newDate.getDate()).padStart(2, '0');

    return `${day}-${month}-${year}`;
  };

  const moneyFormatIndia = (number) => {
    if (number !== undefined && number !== '' && !Number.isNaN(Number(number))) {
      number = parseFloat(number);

      number = number.toFixed(2);

      const [integerPart, decimalPart] = number.split('.');

      const lastThreeDigits = integerPart.slice(-3);
      const otherDigits = integerPart.slice(0, -3);

      let formattedIntegerPart;
      if (otherDigits !== '') {
        formattedIntegerPart = `${otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${lastThreeDigits}`;
      } else {
        formattedIntegerPart = lastThreeDigits;
      }

      return `${formattedIntegerPart}.${decimalPart}`;
    }

    return '0.00';
  };

  const formatNumbersInString = (numberString) => {
    // Split the string into an array of number strings
    const numberArray = numberString.split(',').map(num => num.trim());

    // Format each number and join them back into a string
    const formattedNumbers = numberArray.map(num => moneyFormatIndia(num));

    // Join the formatted numbers into a single string
    return formattedNumbers.join(', ');
  };

  const formatDate2 = (dateTime) => {
    if (!dateTime) {
        return "";
    }
    const dateParts = dateTime.split(' ');
    return dateParts.length > 0 ? dateParts[0] : "";
  };

  const [allProfileMaster, setAllProfileMaster] = useState([]);
  const [allSectorOfUnitMaster, setAllSectorOfUnitMaster] = useState([]);
  const [allDlStatusMaster, setAllDlStatusMaster] = useState([]);
  const [allCategoryMaster, setAllCategoryMaster] = useState([]);
  const [allRegionMaster, setAllRegionMaster] = useState([]);
  const [allProductMaster, setAllProductMaster] = useState([]);
  const [allResidenceStatusMaster, setAllResidenceStatusMaster] = useState([]);

  useEffect(() => {
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getAllAdditionalMissingData(requestData,false);
    response.then((result) => {
        // console.log("Promise resolved -  getAllAdditionalMissingData list:", result);
        if (result.data.success === 1) {
                const results = result.data.data;

                if(Object.prototype.hasOwnProperty.call(results, 'profile_master')){
                  setAllProfileMaster(results.profile_master);
                }

                if(Object.prototype.hasOwnProperty.call(results, 'sector_of_unit_master')){
                    setAllSectorOfUnitMaster(results.sector_of_unit_master);
                }

                if(Object.prototype.hasOwnProperty.call(results, 'dl_status_master')){
                    setAllDlStatusMaster(results.dl_status_master);
                }

                if(Object.prototype.hasOwnProperty.call(results, 'category_master')){
                    setAllCategoryMaster(results.category_master);
                }

                if(Object.prototype.hasOwnProperty.call(results, 'region_master')){
                    setAllRegionMaster(results.region_master);
                }

                if(Object.prototype.hasOwnProperty.call(results, 'product_master')){
                    setAllProductMaster(results.product_master);
                }

                if(Object.prototype.hasOwnProperty.call(results, 'residence_status_master')){
                    setAllResidenceStatusMaster(results.residence_status_master);
                }
            }
        }).catch((error) => {
            console.error("Promise rejected -  getAllAdditionalMissingData :", error);
        });   
    
}, [setAllProfileMaster, setAllSectorOfUnitMaster, setAllDlStatusMaster, setAllCategoryMaster, setAllRegionMaster, setAllProductMaster, setAllResidenceStatusMaster]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({
        ...formValues,
        [name]: value,
    });

  };
  useEffect(() => {

    if(additionalMissingData){

      setValue("residence_status", additionalMissingData.residence_status);
      setValue("priority_type", additionalMissingData.priority_type);
      setValue("type_topic", additionalMissingData.type_topic);
      setValue("profile", additionalMissingData.profile);
      setValue("msme", additionalMissingData.msme);
      setValue("stability", additionalMissingData.stability);
      setValue("sector_of_unit", additionalMissingData.sector_of_unit);
      setValue("sub_sector", additionalMissingData.sub_sector);
      setValue("business_of_occupation", additionalMissingData.business_of_occupation);
      setValue("turnover", additionalMissingData.turnover);
      setValue("dl_number", additionalMissingData.dl_number);
      setValue("dl_status", additionalMissingData.dl_status);
      setValue("category", additionalMissingData.category);
      setValue("region", additionalMissingData.region);
      setValue("city_stability", additionalMissingData.city_stability);
      setValue("business_stability", additionalMissingData.business_stability);
      setValue("driving_experience", additionalMissingData.driving_experience);
      setValue("product", additionalMissingData.product);
      setValue("relation_with_applicant", additionalMissingData.relation_with_applicant);
      setValue("battery_number", additionalMissingData.battery_number);
      setValue("deployment_of_asset", additionalMissingData.deployment_of_asset);
      setValue("warranty_detail", additionalMissingData.warranty_detail);
      setValue("residence_stability", additionalMissingData.residence_stability);

      setValue("insurance_validity_date", formatDate2(additionalMissingData.insurance_validity_date));
      setValue("sanction_date", formatDate2(additionalMissingData.sanction_date));

      const initialFormValues = {
        priority_type: additionalMissingData.priority_type,
        type_topic: additionalMissingData.type_topic,
        residence_status: additionalMissingData.residence_status,
        profile: additionalMissingData.profile,
        msme: additionalMissingData.msme,
        insurance_validity_date: additionalMissingData.insurance_validity_date,
        sanction_date: additionalMissingData.sanction_date,
        stability: additionalMissingData.stability,
        sector_of_unit: additionalMissingData.sector_of_unit,
        sub_sector: additionalMissingData.sub_sector,
        business_of_occupation: additionalMissingData.business_of_occupation,
        turnover: additionalMissingData.turnover,
        dl_number: additionalMissingData.dl_number,
        dl_status: additionalMissingData.dl_status,
        category: additionalMissingData.category,
        region: additionalMissingData.region,
        city_stability: additionalMissingData.city_stability,
        residence_stability: additionalMissingData.residence_stability,
        business_stability: additionalMissingData.business_stability,
        driving_experience: additionalMissingData.driving_experience,
        product: additionalMissingData.product,
        relation_with_applicant: additionalMissingData.relation_with_applicant,
        battery_number: additionalMissingData.battery_number,
        deployment_of_asset: additionalMissingData.deployment_of_asset,
        warranty_detail: additionalMissingData.warranty_detail,
      };
   
    setFormValues(initialFormValues);
    }
  }, [setValue, additionalMissingData]);

  const onSubmit = (data) => {

    const params = {
      'agreementNo': vitem.AgreementNo,
      "priority_type": formValues.priority_type,
      "type_topic": formValues.type_topic,
      "residence_status": formValues.residence_status,
      "profile": formValues.profile,
      "msme": formValues.msme,
      "insurance_validity_date": data.insurance_validity_date,
      "sanction_date": data.sanction_date,
      "stability": formValues.stability,
      "sector_of_unit": formValues.sector_of_unit,
      "sub_sector": formValues.sub_sector,
      "business_of_occupation": formValues.business_of_occupation,
      "turnover": formValues.turnover,
      "dl_number": formValues.dl_number,
      "dl_status": formValues.dl_status,
      "category": formValues.category,
      "region": formValues.region,
      "city_stability": formValues.city_stability,
      "residence_stability": formValues.residence_stability,
      "business_stability": formValues.business_stability,
      "driving_experience": formValues.driving_experience,
      "product": formValues.product,
      "relation_with_applicant": formValues.relation_with_applicant,
      "battery_number": formValues.battery_number,
      "deployment_of_asset": formValues.deployment_of_asset,
      "warranty_detail": formValues.warranty_detail
    }

    const requestData = encryptData(params);
    const response = actions.addEditAdditionalMissingData(requestData, false);
    response.then((result) => {
      // console.log("Promise resolved -  lead list:", result);
      if (result.data.success === 1) {
        setPreloaderStatus(false);
        toast.success(result.data.message, {
          position: "top-right",
        });
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
    }).catch((error) => {
      setPreloaderStatus(false);
      console.error("Promise rejected -  lead list:", error);
    });
  }


   const handlePageChange = (newPage) => {
          setCurrentPage(newPage);
      };
  
      const filteredItems = (allUploadLeadDocument ?? []).filter(item =>
          item.formatetdID.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.assignedUser.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.statusName.toLowerCase().includes(searchQuery.toLowerCase())
      );
  
  
      const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
      const endIndex = startIndex + config.ITEMS_PER_PAGE;
      const paginatedItems = filteredItems.slice(startIndex, endIndex);
      const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);
      const [open, setOpen] = useState(false);
      const [openPayment, setOpenPayment] = useState(false);
      const [viewModalInfo, setViewModalInfo] = useState([]);
      const [latestLocation, setLatestLocation] = useState({});
      const [rawHistoryData, setRawHistoryData] = useState([]);
      const [multiVisitData, setMultiVisitData] = useState([]);
      const [homeBaseData, setHomeBaseData] = useState([]);
      const [poiPagination, setPoiPagination] = useState({});
      const onRowClickAction = (itemObj, btnAction) => {
        setViewModalInfo(itemObj);
        setOpenPayment(true);
      }

    const handleClose = () => {
        setOpenPayment(false);
    };


    const getLoanNOCDetailsData = async (action='',notes='') => {
    
            const actionStatus = '0';
            let submitStatus =  true;
             
            if(refNo ===''){
                toast.error("Reference No is required.", {
                    position: "top-right",
                });
                submitStatus =  false;
            }   
            if(refDate ===''){
                toast.error("Date is required.", {
                    position: "top-right",
                });
                submitStatus =  false;
            } 
            if(regionalTransportAuthority ===''){
                toast.error("Regional Transport Authority is required.", {
                    position: "top-right",
                });
                submitStatus =  false;
            } 
 
                if(submitStatus){ 
                   
                if (vitem.AgreementNo !== undefined) { 
                 let readyToSubmit = true; 
    
                const additionalDetails = { "refNo" : refNo, "refDate" : refDate , "regionalTransportAuthority" : regionalTransportAuthority} 
                  
                let obj = { 'start': '0', 'length': config.MAX_RECORDS, "AgreementNo": vitem.AgreementNo,"action_status":actionStatus ,"sendEmail" : sendEmailBtnAction,"additionalDetails":additionalDetails };
                if(enableUpdatePdfDetails){
                     if(refNo === ''){ 
                        readyToSubmit = true;
                    }   
                    
                    obj = { 'start': '0', 'length': config.MAX_RECORDS, "AgreementNo": vitem.AgreementNo, "enableUpdatePdfDetails" : enableUpdatePdfDetails ,"action_status":actionStatus,"sendEmail" : sendEmailBtnAction,"additionalDetails":additionalDetails }; 
                } 
    
                if(readyToSubmit) {
                     // console.log("obj lead id- ", obj);
                    const requestData = encryptData(obj);
                    const response = actions.getLoanNOCDetailsData(requestData);
    
                    response.then((result) => {
                        setOpenRejectAmt(false);
                        setApproveBtnAction(0);
                        setSendEmailBtnAction(0);
                        // console.log("Promise resolved -  source data:", result); 
                        if (result.data.success === 1) {
                            const resultArr = result.data.data; 
                             
                            const applicationDetailsInfo = resultArr?.latestApplicationDetailsRowInfo;
                            setSavedApplicationDetailsInfo(applicationDetailsInfo); 
                           
                            if(applicationDetailsInfo !== null ){ 

                              setLatestDownloadedByName(applicationDetailsInfo?.latestDownloadedByName || ''); 
                               setLatestDownloadedDateFormat(applicationDetailsInfo?.latestDownloadedDateFormat || '');
                                console.log("111111111 applicationDetailsInfo?.resultArr = ", applicationDetailsInfo);
                               
                            if(applicationDetailsInfo?.additionalDetails){
                                console.log("222222 applicationDetailsInfo?.resultArr = ", applicationDetailsInfo?.additionalDetails);
                                const parsedData = JSON.parse(applicationDetailsInfo?.additionalDetails);
                                setRefNo(parsedData.refNo);
                                setRefDate(parsedData.refDate);
                                setRegionalTransportAuthority(parsedData.regionalTransportAuthority);
                            }   
                            }  
                             setEnableUpdatePdfDetails(prevState => !prevState); 
                        }
    
                       // getCAMDetailsData();
                    }).catch((error) => {
                        //  console.error("Promise rejected -  source data :", error); 
                    });
                }
            }
        } 
         
        };

    const handleToggleUpdateDetails = () =>{
        setEnableUpdatePdfDetails(prevState => !prevState); 
    }

    const handleToggleSaveDetails = () =>{ 
        getLoanNOCDetailsData(); 
    }
 
    const saveDownloadHistory = async () => {
      if (vitem.AgreementNo !== undefined) { 
              const obj = { 'start': '0', 'length': config.MAX_RECORDS, "AgreementNo": vitem.AgreementNo }; 
                  // console.log("obj lead id- ", obj);
                  const requestData = encryptData(obj);
                  const response = actions.saveDownloadHistory(requestData);
  
                  response.then((result) => { 
                      if (result.data.success === 1) { 
                          const resultArr = result.data.data; 
                             console.log("saveDownloadHistory resultArr = ", resultArr);
                           
                         setLatestDownloadedByName(resultArr?.latestDownloadRowInfo?.latestDownloadedByName || ''); 
                          setLatestDownloadedDateFormat(resultArr?.latestDownloadRowInfo?.latestDownloadedDateFormat || '');
                         console.error("Log saved successfully"); 
                      }
                  }).catch((error) => {
                      //  console.error("Promise rejected -  source data :", error); 
                  });
               
          }
         
        };

    // Due Reminder Notice: Get company details based on Agreement Number
    const getCompanyDetails = (agreementNo) => {
      if (!agreementNo) {
        // Default to cKers if no agreement number
        return {
          name: "cKers Finance Private Limited",
          address: "Building No-24-30, First Floor, Okhla Industrial Estate, Phase-III, New Delhi 110020, INDIA",
          contact: "Phone +91-11-41070629 contact@ckersfinance.in",
          hasContact: true,
          logo: 'ckern-logo.png' // Assuming you have a logo for cKers Finance
        };
      }

      // Check if agreement number starts with VCLVL (case insensitive)
      if (agreementNo.toUpperCase().startsWith('VCLVL')) {
        return {
          name: "Vivriti Capital Limited",
          address: "Prestige Zackria Metropolitan, No. 200/1-8, 2nd Floor, Block 1, Anna Salai, Chennai - 600002",
          contact: "",
          hasContact: false,
          logo: 'vivriti-logo.png' // Assuming you have a logo for Vivriti Capital Limited
        };
      }

      // Default to cKers Finance for CKVL and other patterns
      return {
        name: "cKers Finance Private Limited",
        address: "Building No-24-30, First Floor, Okhla Industrial Estate, Phase-III, New Delhi 110020, INDIA",
        contact: "Phone +91-11-41070629 contact@ckersfinance.in",
        hasContact: true
      };
    };

    // Helper function to format date to dd-mm-yyyy
    const formatDateToDDMMYYYY = (dateString) => {
      if (!dateString) return '-';

      try {
        // Handle different date formats
        let date;

        // Check if it's already in dd-mm-yyyy or dd/mm/yyyy format
        if (dateString.match(/^\d{2}[-/]\d{2}[-/]\d{4}$/)) {
          const parts = dateString.split(/[-/]/);
          date = new Date(parts[2], parts[1] - 1, parts[0]);
        }
        // Check if it's in yyyy-mm-dd format
        else if (dateString.match(/^\d{4}[-/]\d{2}[-/]\d{2}/)) {
          date = new Date(dateString);
        }
        // Try parsing as general date
        else {
          date = new Date(dateString);
        }

        // Check if date is valid
        if (Number.isNaN(date.getTime())) {
          return dateString; // Return original if parsing fails
        }

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
      } catch (error) {
        console.error('Date formatting error:', error);
        return dateString; // Return original on error
      }
    };

    // Helper function to convert number to words in Indian format
    const convertAmountToWords = (amount) => {
      if (!amount || Number.isNaN(Number(amount))) return '';

      try {
        const numericAmount = Math.floor(parseFloat(amount));

        // Arrays for number words
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        // Helper function to convert two digits
        const convertTwoDigits = (num) => {
          if (num === 0) return '';
          if (num < 10) return ones[num];
          if (num < 20) return teens[num - 10];
          const tenDigit = Math.floor(num / 10);
          const oneDigit = num % 10;
          return `${tens[tenDigit]}${oneDigit > 0 ? ` ${ones[oneDigit]}` : ''}`;
        };

        // Helper function to convert three digits
        const convertThreeDigits = (num) => {
          if (num === 0) return '';
          const hundred = Math.floor(num / 100);
          const remainder = num % 100;
          let result = '';
          if (hundred > 0) {
            result = `${ones[hundred]} Hundred`;
          }
          if (remainder > 0) {
            result += `${result ? ' ' : ''}${convertTwoDigits(remainder)}`;
          }
          return result;
        };

        if (numericAmount === 0) return 'Zero';

        // Break down the number according to Indian numbering system
        const crore = Math.floor(numericAmount / 10000000);
        const lakh = Math.floor((numericAmount % 10000000) / 100000);
        const thousand = Math.floor((numericAmount % 100000) / 1000);
        const hundred = numericAmount % 1000;

        let words = '';

        if (crore > 0) {
          words += `${convertTwoDigits(crore)} Crore`;
        }

        if (lakh > 0) {
          words += `${words ? ' ' : ''}${convertTwoDigits(lakh)} Lakh`;
        }

        if (thousand > 0) {
          words += `${words ? ' ' : ''}${convertTwoDigits(thousand)} Thousand`;
        }

        if (hundred > 0) {
          words += `${words ? ' ' : ''}${convertThreeDigits(hundred)}`;
        }

        return words.trim();
      } catch (error) {
        console.error('Amount to words conversion error:', error);
        return '';
      }
    };

    // Helper function to get borrower address based on type
    const getBorrowerAddress = (borrowerName, borrowerType, allCoApplicants, allGuarantors, applicantAddress) => {
      // For applicant, return the applicant address directly
      if (borrowerType === 'applicant') {
        return applicantAddress || '-';
      }

      // Determine which array to search based on borrower type
      const searchArray = borrowerType === 'co-applicant' ? allCoApplicants : allGuarantors;

      // If the array is empty or undefined, return '-'
      if (!searchArray || !Array.isArray(searchArray) || searchArray.length === 0) {
        return '-';
      }

      // If borrowerName is not provided, return '-'
      if (!borrowerName) {
        return '-';
      }

      // Normalize the borrower name for comparison (lowercase, trim spaces)
      const normalizedBorrowerName = borrowerName.toLowerCase().trim();

      // Search for a match in the array
      const match = searchArray.find((item) => {
        if (!item.first_name) return false;

        // Normalize the first_name from API (lowercase, trim spaces)
        const normalizedFirstName = item.first_name.toLowerCase().trim();

        // Perform partial/like match (case-insensitive)
        return normalizedBorrowerName.includes(normalizedFirstName) || normalizedFirstName.includes(normalizedBorrowerName);
      });

      // Return the full_address if match found, otherwise return '-'
      return match?.full_address || '-';
    };

    // Due Reminder Notice: Generate sub-tabs based on lstCoBorrowers
    const generateDueReminderSubTabs = () => {
      console.log("=== generateDueReminderSubTabs Debug ===");

       const parsedApiResponse = JSON.parse(vitem.api_response); 
     
      console.log("vitem?.lstCoBorrowers = ", parsedApiResponse?.lstCoBorrowers);

      if (!parsedApiResponse?.lstCoBorrowers || !Array.isArray(parsedApiResponse .lstCoBorrowers)) {
        console.log("lstCoBorrowers is not available or not an array");
        return [];
      }

      if (parsedApiResponse.lstCoBorrowers.length === 0) {
        console.log("lstCoBorrowers is empty");
        return [];
      }

      const subTabs = [];
      let coApplicantCount = 0;
      let guarantorCount = 0;

      console.log("Processing lstCoBorrowers, length:", parsedApiResponse.lstCoBorrowers.length);

      parsedApiResponse.lstCoBorrowers.forEach((borrower, index) => {
        console.log(`Borrower ${index}:`, borrower);
        if (borrower.EntityTypeId === "Customer" && borrower.OrderTypeId === "Primary") {
          subTabs.push({
            id: 'applicant',
            label: 'Applicant',
            borrower,
            type: 'applicant'
          });
        } else if (borrower.EntityTypeId === "Customer" && borrower.OrderTypeId === "Secondary") {
          coApplicantCount += 1;
          const label = coApplicantCount === 1 ? 'Co-applicant' : `Co-applicant ${coApplicantCount}`;
          subTabs.push({
            id: `co-applicant-${coApplicantCount}`,
            label,
            borrower,
            type: 'co-applicant'
          });
        } else if (borrower.EntityTypeId === "Guarantor" && borrower.OrderTypeId === "Primary") {
          guarantorCount += 1;
          const label = guarantorCount === 1 ? 'Guarantor' : `Guarantor ${guarantorCount}`;
          subTabs.push({
            id: `guarantor-${guarantorCount}`,
            label,
            borrower,
            type: 'guarantor'
          });

          } else if (borrower.EntityTypeId === "Guarantor" && borrower.OrderTypeId === "Secondary") {
            guarantorCount += 1;
            const label = guarantorCount === 1 ? 'Guarantor' : `Guarantor ${guarantorCount}`;
            subTabs.push({
              id: `guarantor-${guarantorCount}`,
              label,
              borrower,
              type: 'guarantor'
            });
          }

      });

      console.log("Generated subTabs:", subTabs);
      console.log("=== End generateDueReminderSubTabs Debug ===");
      return subTabs;
    };

    // Due Reminder Notice: Save download history for a specific borrower
    const saveDueReminderDownloadHistory = async (borrowerType, borrowerId) => {
      if (vitem.AgreementNo !== undefined) {
        const obj = {
          "AgreementNo": vitem.AgreementNo,
          "borrowerType": borrowerType,
          "borrowerId": borrowerId,
          "documentType": "due_reminder_notice"
        };
        const requestData = encryptData(obj);
        const response = actions.saveDueReminderDownloadHistory(requestData);

        response.then((result) => {
          if (result.data.success === 1) {
            const resultArr = result.data.data;
            console.log("saveDueReminderDownloadHistory resultArr = ", resultArr);

            // Update download history for this specific borrower
            setDueReminderDownloadHistory(prev => ({
              ...prev,
              [`${borrowerType}-${borrowerId}`]: {
                downloadedBy: resultArr?.latestDownloadRowInfo?.latestDownloadedByName || '',
                downloadedDate: resultArr?.latestDownloadRowInfo?.latestDownloadedDateFormat || ''
              }
            }));
            console.log("Due Reminder Notice download log saved successfully");
          }
        }).catch((error) => {
          console.error("Promise rejected - saveDueReminderDownloadHistory:", error);
        });
      }
    };

    // Due Reminder Notice: Download PDF for a specific borrower
    const handleDueReminderDownloadPdf = async (borrowerType, borrowerId, borrowerName, subTabId) => {
      const element = document.getElementById(`due-reminder-preview-${subTabId}`);
      if (!element) {
        console.error('Printable element not found');
        return;
      }

      setDueReminderPreloader(true);

      try {
        const canvas = await html2canvas(element, {
          scale: 1,
          useCORS: true,
          allowTaint: false,
          scrollY: -window.scrollY
        });

        const pdf = new JsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
        const pdfW = pdf.internal.pageSize.getWidth();
        const pdfH = pdf.internal.pageSize.getHeight();

        // Add padding: 10mm top, 10mm left, 10mm right
        const paddingTop = 10;
        const paddingLeft = 10;
        const paddingRight = 10;

        const imgW = pdfW - paddingLeft - paddingRight;
        const imgH = (canvas.height * imgW) / canvas.width;
        const pagePxH = Math.floor((canvas.width * (pdfH - paddingTop)) / imgW);
        const pages = Math.ceil(canvas.height / pagePxH);

        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        const pageCtx = pageCanvas.getContext('2d');

        for (let page = 0; page < pages; page += 1) {
          const startY = page * pagePxH;
          const sliceH = Math.min(pagePxH, canvas.height - startY);

          if (pageCanvas.height !== sliceH) { pageCanvas.height = sliceH; }

          pageCtx.clearRect(0, 0, canvas.width, sliceH);
          pageCtx.drawImage(canvas, 0, startY, canvas.width, sliceH, 0, 0, canvas.width, sliceH);
          const imgData = pageCanvas.toDataURL('image/jpeg', 0.7);

          if (page > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', paddingLeft, paddingTop, imgW, (sliceH * imgW) / canvas.width);
        }

        const ts = new Date().toISOString().replace(/[:.]/g, '-');
        const prefix = `due_reminder_${borrowerType}_${borrowerName.replace(/\s+/g, '_')}`;
        pdf.save(`${prefix}_${ts}.pdf`);

        // Save download history
        await saveDueReminderDownloadHistory(borrowerType, borrowerId);

        setDueReminderPreloader(false);
      } catch (error) {
        console.error('Error generating PDF:', error);
        setDueReminderPreloader(false);
      }
    };

    const printRef = useRef();
    const handleDownloadPdf = async () => {
        const element = printRef.current;
        if (!element) {
            console.error('Printable element not found');
            return;
        }

        setPreloaderStatus(true);

        /* ---------- 1. Render the DOM node to a single canvas ---------- */
        const canvas = await html2canvas(element, {
            scale   : 1,          // lower scale → smaller PDF, still readable on A4
            useCORS : true,       // remote images must have Access‑Control‑Allow‑Origin
            allowTaint: false,
            scrollY : -window.scrollY
        });

        /* ---------- 2. Prepare jsPDF ---------- */
        const pdf       = new JsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
        const pdfW      = pdf.internal.pageSize.getWidth();
        const pdfH      = pdf.internal.pageSize.getHeight();
        const imgW      = pdfW;
        const imgH      = (canvas.height * pdfW) / canvas.width;      // keep aspect ratio
        const pagePxH   = Math.floor((canvas.width * pdfH) / pdfW);   // canvas pixels per PDF page
        const pages     = Math.ceil(canvas.height / pagePxH);

        /* ---------- 3. Re‑use ONE off‑screen canvas for all page slices ---------- */
        const pageCanvas        = document.createElement('canvas');
        pageCanvas.width        = canvas.width;
        const pageCtx           = pageCanvas.getContext('2d');

        /* ---------- 4. Loop over pages ---------- */
        for (let page = 0; page < pages; page += 1) {
            const startY  = page * pagePxH;
            const sliceH  = Math.min(pagePxH, canvas.height - startY);

            // resize helper canvas only when height changes (last page)
            if (pageCanvas.height !== sliceH) { pageCanvas.height = sliceH; }

            pageCtx.clearRect(0, 0, canvas.width, sliceH);
            pageCtx.drawImage(canvas, 0, startY, canvas.width, sliceH, 0, 0, canvas.width, sliceH);
            const imgData = pageCanvas.toDataURL('image/jpeg', 0.7);

            // add to PDF
            if (page > 0) pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, 0, imgW, (sliceH * pdfW) / canvas.width);
        }

        /* ---------- 5. Build filename & save ---------- */
        const ts = new Date().toISOString().replace(/[:.]/g, '-');

        
        const prefix =  'noObjectionCertificate';

        pdf.save(`${prefix}_${ts}.pdf`);
        saveDownloadHistory();
        setPreloaderStatus(false);
        };


  const handleFormChange = (event) =>{
      if(event.target.name ==='refNo'){
            setRefNo(event.target.value);
      }
      if(event.target.name ==='refDate'){
          setRefDate(event.target.value); 
      }
      if(event.target.name ==='regionalTransportAuthority'){
          setRegionalTransportAuthority(event.target.value); 
      }
   }
  

  return (
    <>

      <div className="mt-4 portlet light d-none">
        <h6 className="  portlet-title">Loan Details</h6>
        <div className="row row mx-0">
          <div className="col-md-4">
            <div className="">
              <div><b>FinanceId : </b></div>
              {loanDetailsArr && loanDetailsArr.FinanceId !== undefined ? (
                <>{loanDetailsArr.FinanceId}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>CompanyRoleId : </b></div>
              {loanDetailsArr && loanDetailsArr.CompanyRoleId !== undefined ? (
                <>{loanDetailsArr.CompanyRoleId}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>LoanType : </b></div>
              {loanDetailsArr && loanDetailsArr.LoanType !== undefined ? (
                <>{loanDetailsArr.LoanType}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>AssetId : </b></div>
              {loanDetailsArr && loanDetailsArr.AssetId !== undefined ? (
                <>{loanDetailsArr.AssetId}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>TotalAmount : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalAmount !== undefined ? (
                <>{loanDetailsArr.TotalAmount}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>Duration : </b></div>
              {loanDetailsArr && loanDetailsArr.Duration !== undefined ? (
                <>{loanDetailsArr.Duration}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>Interest : </b></div>
              {loanDetailsArr && loanDetailsArr.Interest !== undefined ? (
                <>{loanDetailsArr.Interest}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>EMI : </b></div>
              {loanDetailsArr && loanDetailsArr.EMI !== undefined ? (
                <>{loanDetailsArr.EMI}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>YearlyInterest : </b></div>
              {loanDetailsArr && loanDetailsArr.YearlyInterest !== undefined ? (
                <>{loanDetailsArr.YearlyInterest}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>StartDate : </b></div>
              {loanDetailsArr && loanDetailsArr.StartDate !== undefined ? (
                <>{loanDetailsArr.StartDate}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>LoanClosureDate : </b></div>
              {loanDetailsArr && loanDetailsArr.LoanClosureDate !== undefined ? (
                <>{loanDetailsArr.LoanClosureDate}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>DPDDays : </b></div>
              {loanDetailsArr && loanDetailsArr.DPDDays !== undefined ? (
                <>{loanDetailsArr.DPDDays}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>AgreementNo : </b></div>
              {loanDetailsArr && loanDetailsArr.AgreementNo !== undefined ? (
                <>{loanDetailsArr.AgreementNo}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>FutureValue : </b></div>
              {loanDetailsArr && loanDetailsArr.FutureValue !== undefined ? (
                <>{loanDetailsArr.FutureValue}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>InsuranceAmount : </b></div>
              {loanDetailsArr && loanDetailsArr.InsuranceAmount !== undefined ? (
                <>{loanDetailsArr.InsuranceAmount}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>InsuranceDuration : </b></div>
              {loanDetailsArr && loanDetailsArr.InsuranceDuration !== undefined ? (
                <>{loanDetailsArr.InsuranceDuration}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>IndicativeROI : </b></div>
              {loanDetailsArr && loanDetailsArr.IndicativeROI !== undefined ? (
                <>{loanDetailsArr.IndicativeROI}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>SendSMS : </b></div>
              {loanDetailsArr && loanDetailsArr.SendSMS !== undefined ? (
                <>{loanDetailsArr.SendSMS}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>SchemeId : </b></div>
              {loanDetailsArr && loanDetailsArr.SchemeId !== undefined ? (
                <>{loanDetailsArr.SchemeId}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>EMITypeId : </b></div>
              {loanDetailsArr && loanDetailsArr.EMITypeId !== undefined ? (
                <>{loanDetailsArr.EMITypeId}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>LPCAmount : </b></div>
              {loanDetailsArr && loanDetailsArr.LPCAmount !== undefined ? (
                <>{loanDetailsArr.LPCAmount}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>LPCType : </b></div>
              {loanDetailsArr && loanDetailsArr.LPCType !== undefined ? (
                <>{loanDetailsArr.LPCType}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>LPCInterest : </b></div>
              {loanDetailsArr && loanDetailsArr.LPCInterest !== undefined ? (
                <>{loanDetailsArr.LPCInterest}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>InstallmentTypeId : </b></div>
              {loanDetailsArr && loanDetailsArr.InstallmentTypeId !== undefined ? (
                <>{loanDetailsArr.InstallmentTypeId}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>ROIDuration : </b></div>
              {loanDetailsArr && loanDetailsArr.ROIDuration !== undefined ? (
                <>{loanDetailsArr.ROIDuration}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>SubLoanTypeForPL : </b></div>
              {loanDetailsArr && loanDetailsArr.SubLoanTypeForPL !== undefined ? (
                <>{loanDetailsArr.SubLoanTypeForPL}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>LoanCategory : </b></div>
              {loanDetailsArr && loanDetailsArr.LoanCategory !== undefined ? (
                <>{loanDetailsArr.LoanCategory}</>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>DownPayment : </b></div>
              {loanDetailsArr && loanDetailsArr.DownPayment !== undefined ? (
                <>{loanDetailsArr.DownPayment}</>
              ) : (
                <></>
              )}

            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>AdvanceEMI : </b></div>
              {loanDetailsArr && loanDetailsArr.AdvanceEMI !== undefined ? (
                <>{loanDetailsArr.AdvanceEMI}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>LoanSegmentId : </b></div>
              {loanDetailsArr && loanDetailsArr.LoanSegmentId !== undefined ? (
                <>{loanDetailsArr.LoanSegmentId}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>UTRNo : </b></div>
              {loanDetailsArr && loanDetailsArr.UTRNo !== undefined ? (
                <>{loanDetailsArr.UTRNo}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>DisbursementStatus : </b></div>
              {loanDetailsArr && loanDetailsArr.DisbursementStatus !== undefined ? (
                <>{loanDetailsArr.DisbursementStatus}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>NachStatusId : </b></div>
              {loanDetailsArr && loanDetailsArr.NachStatusId !== undefined ? (
                <>{loanDetailsArr.NachStatusId}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>UMRNNumber : </b></div>
              {loanDetailsArr && loanDetailsArr.UMRNNumber !== undefined ? (
                <>{loanDetailsArr.UMRNNumber}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>StatusId : </b></div>
              {loanDetailsArr && loanDetailsArr.StatusId !== undefined ? (
                <>{loanDetailsArr.StatusId}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>EMIStartDate : </b></div>
              {loanDetailsArr && loanDetailsArr.EMIStartDate !== undefined ? (
                <>{loanDetailsArr.EMIStartDate}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>EMIEndDate : </b></div>
              {loanDetailsArr && loanDetailsArr.EMIEndDate !== undefined ? (
                <>{loanDetailsArr.EMIEndDate}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>NextPaymentDate : </b></div>
              {loanDetailsArr && loanDetailsArr.NextPaymentDate !== undefined ? (
                <>{loanDetailsArr.NextPaymentDate}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>NextEMIDueDate : </b></div>
              {loanDetailsArr && loanDetailsArr.NextEMIDueDate !== undefined ? (
                <>{loanDetailsArr.NextEMIDueDate}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>ModeOfRePaymentId : </b></div>
              {loanDetailsArr && loanDetailsArr.ModeOfRePaymentId !== undefined ? (
                <>{loanDetailsArr.ModeOfRePaymentId}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>NoOfPaidEMI : </b></div>
              {loanDetailsArr && loanDetailsArr.NoOfPaidEMI !== undefined ? (
                <>{loanDetailsArr.NoOfPaidEMI}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalReceivedAmt : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalReceivedAmt !== undefined ? (
                <>{loanDetailsArr.TotalReceivedAmt}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalPrincipleRecvd : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalPrincipleRecvd !== undefined ? (
                <>{loanDetailsArr.TotalPrincipleRecvd}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalInterestPaid : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalInterestPaid !== undefined ? (
                <>{loanDetailsArr.TotalInterestPaid}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>EMIDueCount : </b></div>
              {loanDetailsArr && loanDetailsArr.EMIDueCount !== undefined ? (
                <>{loanDetailsArr.EMIDueCount}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalPrincipalDue : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalPrincipalDue !== undefined ? (
                <>{loanDetailsArr.TotalPrincipalDue}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalInterestDue : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalInterestDue !== undefined ? (
                <>{loanDetailsArr.TotalInterestDue}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalVASDues : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalVASDues !== undefined ? (
                <>{loanDetailsArr.TotalVASDues}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalDueAmount : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalDueAmount !== undefined ? (
                <>{loanDetailsArr.TotalDueAmount}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>LPIDues : </b></div>
              {loanDetailsArr && loanDetailsArr.LPIDues !== undefined ? (
                <>{loanDetailsArr.LPIDues}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>DefaultChrages : </b></div>
              {loanDetailsArr && loanDetailsArr.DefaultChrages !== undefined ? (
                <>{loanDetailsArr.DefaultChrages}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalEMIOverdueAmount : </b></div>
              {loanDetailsArr && loanDetailsArr.TotalEMIOverdueAmount !== undefined ? (
                <>{loanDetailsArr.TotalEMIOverdueAmount}</>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="">
              <div><b>TotalLoanOverdueAmount : </b></div>

              {/* JavaScript logic */}
              {(() => {
                let totalLoanOverdueAmountUpdatedStatus = false;
                let totalLoanOverdueAmountDeletedStatus = false;
                let totalLoanOverdueAmountObj = {};

                if (loanDetailsModifiedArr && Object.prototype.hasOwnProperty.call(loanDetailsModifiedArr, 'TotalLoanOverdueAmount')) {
                  totalLoanOverdueAmountObj = loanDetailsModifiedArr.TotalLoanOverdueAmount;

                  if (totalLoanOverdueAmountObj && Object.prototype.hasOwnProperty.call(totalLoanOverdueAmountObj, 'old') && Object.prototype.hasOwnProperty.call(totalLoanOverdueAmountObj, 'new')) {
                    totalLoanOverdueAmountUpdatedStatus = true;
                  }

                  if (totalLoanOverdueAmountObj && Object.prototype.hasOwnProperty.call(totalLoanOverdueAmountObj, 'delete')) {
                    totalLoanOverdueAmountDeletedStatus = totalLoanOverdueAmountObj.delete;
                  }
                }

                return (
                  <>
                    {!totalLoanOverdueAmountDeletedStatus && totalLoanOverdueAmountUpdatedStatus ? (
                      <>
                        <div className="text-danger">Old:{(loanDetailsModifiedArr.old !== null && loanDetailsModifiedArr.old !== '') ? moneyFormatIndia(loanDetailsModifiedArr.old) : ''}</div>
                        <div className="text-success">New:{(loanDetailsModifiedArr.new !== null && loanDetailsModifiedArr.new !== '') ? moneyFormatIndia(loanDetailsModifiedArr.new) : ''}</div>
                      </>
                    ) : (loanDetailsArr && loanDetailsArr.TotalLoanOverdueAmount !== undefined ? (
                      <>{loanDetailsArr.TotalLoanOverdueAmount}</>
                    ) : (
                      <><div className='deletedRow'>Deleted</div></>
                    ))}
                  </>
                );
              })()}
            </div>
          </div>

          <div className="col-md-4">
            <div className="">
              <div><b>loanTotalDue : </b></div>

              {/* JavaScript logic */}
              {(() => {
                let loanTotalDueUpdatedStatus = false;
                let loanTotalDueDeletedStatus = false;
                let loanTotalDueObj = {};

                // console.log("loanDetailsModifiedArr : ", loanDetailsModifiedArr);

                if (loanDetailsModifiedArr && Object.prototype.hasOwnProperty.call(loanDetailsModifiedArr, 'LoanTotalDue')) {
                  loanTotalDueObj = loanDetailsModifiedArr.LoanTotalDue;

                  if (loanTotalDueObj && Object.prototype.hasOwnProperty.call(loanTotalDueObj, 'old') && Object.prototype.hasOwnProperty.call(loanTotalDueObj, 'new')) {
                    loanTotalDueUpdatedStatus = true;
                  }

                  if (loanTotalDueObj && Object.prototype.hasOwnProperty.call(loanTotalDueObj, 'delete')) {
                    loanTotalDueDeletedStatus = loanTotalDueObj.delete;
                  }
                }

                return (
                  <>
                    {loanTotalDueDeletedStatus ? (
                      <div className='deletedRow'>Deleted</div>
                    ) : loanTotalDueUpdatedStatus ? (
                      <>
                        <div className="text-danger">Old:{(loanDetailsModifiedArr.LoanTotalDue.old !== null && loanDetailsModifiedArr.LoanTotalDue.old !== '') ? moneyFormatIndia(loanDetailsModifiedArr.LoanTotalDue.old) : ''}</div>
                        <div className="text-success">New:{(loanDetailsModifiedArr.LoanTotalDue.new !== null && loanDetailsModifiedArr.LoanTotalDue.new !== '') ? moneyFormatIndia(loanDetailsModifiedArr.LoanTotalDue.new) : ''}</div>
                      </>
                    ) : (
                      <>{(loanDetailsArr.loanTotalDue !== null && loanDetailsArr.loanTotalDue !== '') ? moneyFormatIndia(loanDetailsArr.loanTotalDue) : ''}</>
                    )}
                  </>
                );
              })()}
            </div>
          </div>

        </div>
      </div>
      
      <div className="tab-content" id="pills-tabContent">
        <ul className="nav nav-pills mb-4" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={activeTabName === 'schedule' ? "nav-link active" : "nav-link"}
              id="pills-schedule-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-schedule"
              type="button"
              role="tab"
              aria-controls="pills-schedule"
              aria-selected={activeTabName === 'schedule' ? "true" : "false"}
              onClick={backToScheduleHandler}
            >
              EMIs Schedule
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={activeTabName === 'additional' ? "nav-link active" : "nav-link"}
              id="pills-additional-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-additional"
              type="button"
              role="tab"
              aria-controls="pills-additional"
              aria-selected={activeTabName === 'additional' ? "true" : "false"}
              onClick={backToAdditionalHandler}
            >
              Additional Data
            </button>
          </li>

          <li className="nav-item" role="presentation">
            <button
              className={activeTabName === 'payment_documents' ? "nav-link active" : "nav-link"}
              id="pills-payment_documents-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-payment_documents"
              type="button"
              role="tab"
              aria-controls="pills-payment_documents"
              aria-selected={activeTabName === 'payment_documents' ? "true" : "false"}
              onClick={backToPaymentDocumentsHandler}
            >
              Payment Documents
            </button>
          </li>

          <li className="nav-item" role="presentation">
            <button
              className={activeTabName === 'vehicle_inspection_form' ? "nav-link active" : "nav-link"}
              id="pills-vehicle_inspection_form-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-vehicle_inspection_form"
              type="button" 
              role="tab"
              aria-controls="pills-vehicle_inspection_form"
              aria-selected={activeTabName === 'vehicle_inspection_form' ? "true" : "false"}
              onClick={backToVehicleInspectionFormHandler}
            >
              Short Inspection Form
            </button>
          </li>

          <li className="nav-item" role="presentation">
            <button
              className={activeTabName === 'legal_actions' ? "nav-link active" : "nav-link"}
              id="pills-legal_actions-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-legal_actions"
              type="button" 
              role="tab"
              aria-controls="pills-legal_actions"
              aria-selected={activeTabName === 'legal_actions' ? "true" : "false"}
              onClick={backToLegalActionsHandler}
            >
              Legal Actions
            </button>
          </li>

           {( isReadyToModify && ( userRoleType === "Super Admin" || userRoleType === 'Superadmin' || userRoleType === 'Credit Operations' || userRoleType === 'Credit' )) && (
            <>
                <li className="nav-item" role="presentation">
                  <button
                    className={activeTabName === 'no_objection_certificate' ? "nav-link active" : "nav-link"}
                    id="pills-no_objection_certificate-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-no_objection_certificate"
                    type="button"
                    role="tab"
                    aria-controls="pills-no_objection_certificate"
                    aria-selected={activeTabName === 'no_objection_certificate' ? "true" : "false"}
                    onClick={backToNoObjectionCertificateHandler}
                  >
                    No Objection Certificate
                  </button>
                </li>
               
                {/* Due Reminder Notice Tab - Only show if enabled */}
                {vitem?._isDueReminderNoticeEnabled && (
                  <li className="nav-item" role="presentation">
                    <button
                      className={activeTabName === 'due_reminder_notice' ? "nav-link active" : "nav-link"}
                      id="pills-due_reminder_notice-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-due_reminder_notice"
                      type="button"
                      role="tab"
                      aria-controls="pills-due_reminder_notice"
                      aria-selected={activeTabName === 'due_reminder_notice' ? "true" : "false"}
                      onClick={backToDueReminderNoticeHandler}
                    >
                      Due Reminder Notice
                    </button>
                  </li>
                )}
              
              </>
              )} 
               <li className="nav-item" role="presentation">
                  <button
                    className={activeTabName === 'phone_history' ? "nav-link active" : "nav-link"}
                    id="pills-phone-history-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-phone-history"
                    type="button"
                    role="tab"
                    aria-controls="pills-phone-history"
                    aria-selected={activeTabName === 'phone_history' ? "true" : "false"}
                    onClick={backToPhoneHistoryHandler}
                  >
                    Phone Number History
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                      className={activeTabName === 'point_of_interest' ? "nav-link active" : "nav-link"}
                      type="button"
                      onClick={() => setActiveTabName('point_of_interest')}
                  >
                      Point Of Interest
                  </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                    className={activeTabName === 'km_run_history' ? "nav-link active" : "nav-link"}
                    type="button"
                    onClick={() => setActiveTabName('km_run_history')}
                >
                    KM Run History
                </button>
            </li>
        </ul>

        {/* Tab Content */}
        <div className={activeTabName === 'schedule' ? 'tab-pane fade show active' : 'tab-pane fade'} id="pills-schedule" role="tabpanel">
          <div className="mt-4 portlet light">
            <div className='table-wrap table-responsive'>
              <table className="table table-hover mt-4" id="exportLoansReportExcelFile" width="100%">
                <thead>
                  <tr>
                    <th className="text-nowrap">No</th>
                    <th className="text-nowrap">Due Amount</th>
                    <th className="text-nowrap">Principal</th>
                    <th className="text-nowrap">Due Date</th>
                    <th className="text-nowrap">Payment Status</th>
                    <th className="text-right">Paid Amount</th>
                    <th className="text-right">Payment Date</th>

                    <th className="text-nowrap">Interest</th>
                    <th className="text-nowrap">Principal OS</th>
                    <th className="text-nowrap">Pending Amount</th>
                    <th className="text-nowrap">Total Interest</th>
                    <th className="text-nowrap">Principal Round</th>
                    <th className="text-nowrap">Interest Round</th>

                  </tr>
                </thead>
                <tbody>
                  {allEMIsArr.map((item, index) => {

                    let deletedEmiStatus = false;
                    if (
                      allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'InstallmentNo')
                    ) {
                      const installmentObj = allModifiedEMIsArr[index].InstallmentNo;
                      if (
                        installmentObj &&
                        Object.prototype.hasOwnProperty.call(installmentObj, 'delete')
                      ) {
                        deletedEmiStatus = installmentObj.delete;
                      }

                    }


                    let principleUpdatedStatus = false;
                    let principleDeletedStatus = false;
                    let principalObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'Principal')) {
                      principalObj = allModifiedEMIsArr[index].Principal;
                      if (principalObj && Object.prototype.hasOwnProperty.call(principalObj, 'old') && Object.prototype.hasOwnProperty.call(principalObj, 'new')) {
                        principleUpdatedStatus = true;
                      }

                      if (principalObj && Object.prototype.hasOwnProperty.call(principalObj, 'delete')) {
                        principleDeletedStatus = principalObj.delete;
                      }
                    }



                    let dueAmountUpdatedStatus = false;
                    let dueAmountDeletedStatus = false;
                    let dueAmountObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'DueAmount')) {
                      dueAmountObj = allModifiedEMIsArr[index].DueAmount;
                      if (dueAmountObj && Object.prototype.hasOwnProperty.call(dueAmountObj, 'old') && Object.prototype.hasOwnProperty.call(dueAmountObj, 'new')) {
                        dueAmountUpdatedStatus = true;
                      }

                      if (dueAmountObj && Object.prototype.hasOwnProperty.call(dueAmountObj, 'delete')) {
                        dueAmountDeletedStatus = dueAmountObj.delete;
                      }
                    }

                    let paymentStatusUpdatedStatus = false;
                    let paymentStatusDeletedStatus = false;
                    let paymentStatusObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'PaymentStatus')) {
                      paymentStatusObj = allModifiedEMIsArr[index].PaymentStatus;
                      if (paymentStatusObj && Object.prototype.hasOwnProperty.call(paymentStatusObj, 'old') && Object.prototype.hasOwnProperty.call(paymentStatusObj, 'new')) {
                        paymentStatusUpdatedStatus = true;
                      }

                      if (paymentStatusObj && Object.prototype.hasOwnProperty.call(paymentStatusObj, 'delete')) {
                        paymentStatusDeletedStatus = paymentStatusObj.delete;
                      }
                    }


                    let paidAmountUpdatedStatus = false;
                    let paidAmountDeletedStatus = false;
                    let paidAmountObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'PaidAmount')) {
                      paidAmountObj = allModifiedEMIsArr[index].PaidAmount;
                      if (paidAmountObj && Object.prototype.hasOwnProperty.call(paidAmountObj, 'old') && Object.prototype.hasOwnProperty.call(paidAmountObj, 'new')) {
                        paidAmountUpdatedStatus = true;
                      }

                      if (paidAmountObj && Object.prototype.hasOwnProperty.call(paidAmountObj, 'delete')) {
                        paidAmountDeletedStatus = paidAmountObj.delete;
                      }
                    }

                    let interestUpdatedStatus = false;
                    let interestDeletedStatus = false;
                    let interestObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'Interest')) {
                      interestObj = allModifiedEMIsArr[index].Interest;
                      if (interestObj && Object.prototype.hasOwnProperty.call(interestObj, 'old') && Object.prototype.hasOwnProperty.call(interestObj, 'new')) {
                        interestUpdatedStatus = true;
                      }

                      if (interestObj && Object.prototype.hasOwnProperty.call(interestObj, 'delete')) {
                        interestDeletedStatus = interestObj.delete;
                      }
                    }

                    let principalOSUpdatedStatus = false;
                    let principalOSDeletedStatus = false;
                    let principalOSObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'PrincipalOS')) {
                      principalOSObj = allModifiedEMIsArr[index].PrincipalOS;
                      if (principalOSObj && Object.prototype.hasOwnProperty.call(principalOSObj, 'old') && Object.prototype.hasOwnProperty.call(principalOSObj, 'new')) {
                        principalOSUpdatedStatus = true;
                      }

                      if (principalOSObj && Object.prototype.hasOwnProperty.call(principalOSObj, 'delete')) {
                        principalOSDeletedStatus = principalOSObj.delete;
                      }
                    }

                    let pendingAmountUpdatedStatus = false;
                    let pendingAmountDeletedStatus = false;
                    let pendingAmountObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'PendingAmount')) {
                      pendingAmountObj = allModifiedEMIsArr[index].PendingAmount;
                      if (pendingAmountObj && Object.prototype.hasOwnProperty.call(pendingAmountObj, 'old') && Object.prototype.hasOwnProperty.call(pendingAmountObj, 'new')) {
                        pendingAmountUpdatedStatus = true;
                      }

                      if (pendingAmountObj && Object.prototype.hasOwnProperty.call(pendingAmountObj, 'delete')) {
                        pendingAmountDeletedStatus = pendingAmountObj.delete;
                      }
                    }

                    let totalInterestUpdatedStatus = false;
                    let totalInterestDeletedStatus = false;
                    let totalInterestObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'TotalInterest')) {
                      totalInterestObj = allModifiedEMIsArr[index].TotalInterest;
                      if (totalInterestObj && Object.prototype.hasOwnProperty.call(totalInterestObj, 'old') && Object.prototype.hasOwnProperty.call(totalInterestObj, 'new')) {
                        totalInterestUpdatedStatus = true;
                      }

                      if (totalInterestObj && Object.prototype.hasOwnProperty.call(totalInterestObj, 'delete')) {
                        totalInterestDeletedStatus = totalInterestObj.delete;
                      }
                    }

                    let principalRoundUpdatedStatus = false;
                    let principalRoundDeletedStatus = false;
                    let principalRoundObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'PrincipalRound')) {
                      principalRoundObj = allModifiedEMIsArr[index].PrincipalRound;
                      if (principalRoundObj && Object.prototype.hasOwnProperty.call(principalRoundObj, 'old') && Object.prototype.hasOwnProperty.call(principalRoundObj, 'new')) {
                        principalRoundUpdatedStatus = true;
                      }

                      if (principalRoundObj && Object.prototype.hasOwnProperty.call(principalRoundObj, 'delete')) {
                        principalRoundDeletedStatus = principalRoundObj.delete;
                      }
                    }

                    let interestRoundUpdatedStatus = false;
                    let interestRoundDeletedStatus = false;
                    let interestRoundObj = {};
                    if (allModifiedEMIsArr && allModifiedEMIsArr[index] && Object.prototype.hasOwnProperty.call(allModifiedEMIsArr[index], 'InterestRound')) {
                      interestRoundObj = allModifiedEMIsArr[index].InterestRound;
                      if (interestRoundObj && Object.prototype.hasOwnProperty.call(interestRoundObj, 'old') && Object.prototype.hasOwnProperty.call(interestRoundObj, 'new')) {
                        interestRoundUpdatedStatus = true;
                      }

                      if (interestRoundObj && Object.prototype.hasOwnProperty.call(interestRoundObj, 'delete')) {
                        interestRoundDeletedStatus = interestRoundObj.delete;
                      }
                    }

                    return (
                      <>
                        {deletedEmiStatus ? (<>
                          <tr key={index} className={deletedEmiStatus ? 'deletedRow' : ''}>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>Deleted</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                            <td className={deletedEmiStatus ? 'deletedRow' : ''}>&nbsp;</td>
                          </tr>
                        </>) : (<></>)}

                        <tr key={index}>
                          <td>{item.InstallmentNo}</td>
                          <td>
                            {dueAmountUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(dueAmountObj.old !== null && dueAmountObj.old !== '') ? moneyFormatIndia(dueAmountObj.old) : ''}</div>
                                <div className="text-success">New:{(dueAmountObj.new !== null && dueAmountObj.new !== '') ? moneyFormatIndia(dueAmountObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.DueAmount !== null && item.DueAmount !== '') ? <div dangerouslySetInnerHTML={{ __html: item.DueAmount }} /> : ''}
                            </>)}

                          </td>
                          <td>
                            {principleUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(principalObj.old !== null && principalObj.old !== '') ? moneyFormatIndia(principalObj.old) : ''}</div>
                                <div className="text-success">New:{(principalObj.new !== null && principalObj.new !== '') ? moneyFormatIndia(principalObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.Principal !== null && item.Principal !== '') ? <div dangerouslySetInnerHTML={{ __html: item.Principal }} /> : ''}
                            </>)}


                          </td>

                          <td className="text-nowrap">{formatDate(item.DueDate)}</td>
                          <td>
                            {paymentStatusUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(paymentStatusObj.old !== null && paymentStatusObj.old !== '') ? paymentStatusObj.old : ''}</div>
                                <div className="text-success">New:{(paymentStatusObj.new !== null && paymentStatusObj.new !== '') ? paymentStatusObj.new : ''}</div>
                              </>
                            ) : (<>
                              {(item.PaymentStatus !== null && item.PaymentStatus !== '') ? (
                                <div dangerouslySetInnerHTML={{ __html: item.PaymentStatus }} />
                              ) : (
                                ''
                              )}
                            </>)}
                          </td>
                          <td>
                            {paidAmountUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(paidAmountObj.old !== null && paidAmountObj.old !== '') ? formatNumbersInString(paidAmountObj.old) : ''}</div>
                                <div className="text-success">New:{(paidAmountObj.new !== null && paidAmountObj.new !== '') ? formatNumbersInString(paidAmountObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.PaidAmount !== null && item.PaidAmount !== '') ? <div dangerouslySetInnerHTML={{ __html: item.PaidAmount }} /> : ''}
                            </>)}

                          </td>
                          <td className="text-nowrap">{(item.PaymentDate !== null && item.PaymentDate !== '') ? <div dangerouslySetInnerHTML={{ __html: item.PaymentDate }} /> : ''}</td>

                          <td>
                            {interestUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(interestObj.old !== null && interestObj.old !== '') ? moneyFormatIndia(interestObj.old) : ''}</div>
                                <div className="text-success">New:{(interestObj.new !== null && interestObj.new !== '') ? moneyFormatIndia(interestObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.Interest !== null && item.Interest !== '') ? <div dangerouslySetInnerHTML={{ __html: item.Interest }} /> : ''}
                            </>)}

                          </td>
                          <td>

                            {principalOSUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(principalOSObj.old !== null && principalOSObj.old !== '') ? moneyFormatIndia(principalOSObj.old) : ''}</div>
                                <div className="text-success">New:{(principalOSObj.new !== null && principalOSObj.new !== '') ? moneyFormatIndia(principalOSObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.PrincipalOS !== null && item.PrincipalOS !== '') ? <div dangerouslySetInnerHTML={{ __html: item.PrincipalOS }} /> : ''}
                            </>)}

                          </td>
                          <td >
                            {pendingAmountUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(pendingAmountObj.old !== null && pendingAmountObj.old !== '') ? moneyFormatIndia(pendingAmountObj.old) : ''}</div>
                                <div className="text-success">New:{(pendingAmountObj.new !== null && pendingAmountObj.new !== '') ? moneyFormatIndia(pendingAmountObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.PendingAmount !== null && item.PendingAmount !== '') ? <div dangerouslySetInnerHTML={{ __html: item.PendingAmount }} /> : ''}
                            </>)}

                          </td>
                          <td >

                            {totalInterestUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(totalInterestObj.old !== null && totalInterestObj.old !== '') ? moneyFormatIndia(totalInterestObj.old) : ''}</div>
                                <div className="text-success">New:{(totalInterestObj.new !== null && totalInterestObj.new !== '') ? moneyFormatIndia(totalInterestObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.TotalInterest !== null && item.TotalInterest !== '') ? <div dangerouslySetInnerHTML={{ __html: item.TotalInterest }} /> : ''}
                            </>)}

                          </td>
                          <td >
                            {principalRoundUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(principalRoundObj.old !== null && principalRoundObj.old !== '') ? moneyFormatIndia(principalRoundObj.old) : ''}</div>
                                <div className="text-success">New:{(principalRoundObj.new !== null && principalRoundObj.new !== '') ? moneyFormatIndia(principalRoundObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.PrincipalRound !== null && item.PrincipalRound !== '') ? <div dangerouslySetInnerHTML={{ __html: item.PrincipalRound }} /> : ''}
                            </>)}

                          </td>
                          <td >

                            {interestRoundUpdatedStatus ? (
                              <>
                                <div className="text-danger">Old:{(interestRoundObj.old !== null && interestRoundObj.old !== '') ? moneyFormatIndia(interestRoundObj.old) : ''}</div>
                                <div className="text-success">New:{(interestRoundObj.new !== null && interestRoundObj.new !== '') ? moneyFormatIndia(interestRoundObj.new) : ''}</div>
                              </>
                            ) : (<>
                              {(item.InterestRound !== null && item.InterestRound !== '') ? <div dangerouslySetInnerHTML={{ __html: item.InterestRound }} /> : ''}
                            </>)}

                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

       {
    activeTabName === 'point_of_interest' && (
        <div className="card shadow-sm border-0">
            <div className="card-body">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">
                        Point Of Interest
                    </h5>

                    <button
                      className="btn btn-primary"
                      onClick={checkCurrentLocation}
                      disabled={poiLoader}
                  >
                      {poiLoader ? 'Please Wait...' : 'Update POI'}
                  </button>
                </div>

                <div className="accordion mb-3" id="poiAccordion">

                    {/* Last Known Location */}
                    {/* <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#lastKnownLocation"
                            >
                                Latest Location
                            </button>
                        </h2>

                        <div
                            id="lastKnownLocation"
                            className="accordion-collapse collapse show"
                        >
                            <div
                                className="accordion-body"
                                style={{
                                    overflowX: 'auto',
                                    width: '100%',
                                    padding: '15px'
                                }}
                            >

                                <table
    className="table table-bordered table-striped"
    style={{
        minWidth: '2400px',
        whiteSpace: 'nowrap',
        marginBottom: 0
    }}
>
                                    <thead>
                                        <tr>
                                            <th
                                                style={{
                                                    minWidth: '180px',
                                                    padding: '14px 18px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: 600
                                                }}
                                            >Loan Number</th>
                                                                                        <th
                                                style={{
                                                    minWidth: '180px',
                                                    padding: '14px 18px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: 600
                                                }}
                                            >Chassis Number</th>
                                                                                        <th
                                                style={{
                                                    minWidth: '180px',
                                                    padding: '14px 18px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: 600
                                                }}
                                            >Latest Known Location</th>
                                                                                        <th
                                                style={{
                                                    minWidth: '180px',
                                                    padding: '14px 18px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: 600
                                                }}
                                            >Latitude</th>
                                                                                        <th
                                                style={{
                                                    minWidth: '180px',
                                                    padding: '14px 18px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: 600
                                                }}
                                            >Longitude</th>
                                                                                        <th
                                                style={{
                                                    minWidth: '180px',
                                                    padding: '14px 18px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: 600
                                                }}
                                            >Google Map Link</th>
                                        </tr>
                                    </thead>

                                   <tbody>
                                    {latestLocation && Object.keys(latestLocation).length > 0 ? (
                                        <tr>
                                            <td
                                                style={{
                                                    padding: '12px 16px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                {latestLocation.loan_number || '-'}
                                            </td>

                                            <td
                                                style={{
                                                    padding: '12px 16px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                {latestLocation.chassis_number || '-'}
                                            </td>

                                            <td
                                                style={{
                                                    padding: '12px 16px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                {latestLocation.latest_known_location || '-'}
                                            </td>

                                            <td
                                                style={{
                                                    padding: '12px 16px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                {latestLocation.latitude || '-'}
                                            </td>

                                            <td
                                                style={{
                                                    padding: '12px 16px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                {latestLocation.longitude || '-'}
                                            </td>

                                            <td
                                                style={{
                                                    padding: '12px 16px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                {latestLocation.google_map_link ? (
                                                    <a
                                                        href={latestLocation.google_map_link}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View Map
                                                    </a>
                                                ) : (
                                                    '-'
                                                )}
                                            </td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                </table>

                            </div>
                        </div>
                    </div> */}

                    {/* Raw History */}
                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#rawHistory"
                            >
                                Raw History
                            </button>
                        </h2>

                        <div
                            id="rawHistory"
                            className="accordion-collapse collapse"
                        >
                            <div
                                className="accordion-body"
                                style={{
                                          overflowX: 'auto',
                                          width: '100%',
                                          padding: '15px'
                                      }}
                                                              >

                                                                  <table
                                      className="table table-bordered table-striped"
                                      style={{
                                          minWidth: '2400px',
                                          whiteSpace: 'nowrap',
                                          marginBottom: 0
                                      }}
                                  >
                                    <thead>
                                        <tr>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >POI ID</th>
                                                                                          {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Chassis Number</th> */}
                                                                                          {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Registration Number</th> */}
                                                                                          {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Loan Number</th> */}
                                                                                          <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Manufacturer</th>
                                                                                          <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Latitude</th>
                                                                                          <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Longitude</th>
                                                                                          <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Record Date</th>
                                                                                          <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Entry Time</th>
                                                                                          <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Exit Time</th>
                                                                                          <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Average Visit Duration Minutes</th>
                                                                                          <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Google Map Link</th>
                                                                                          {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >POI Category</th> */}
                                        </tr>
                                    </thead>

                                   <tbody>
                                    {rawHistoryData && rawHistoryData.length > 0 ? (
                                        rawHistoryData.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.poi_id || '-'}</td>
                                                {/* <td>{row.chassis_number || '-'}</td>
                                                <td>{row.registration_number || '-'}</td>
                                                <td>{row.loan_number || '-'}</td> */}
                                                <td>{row.manufacturer || '-'}</td>
                                                <td>{row.latitude || '-'}</td>
                                                <td>{row.longitude || '-'}</td>
                                               <td>{row.record_date ? formatDate(row.record_date) : '-'}</td>
                                              <td>{row.entry_time ? formatDate(row.entry_time) : '-'}</td>
                                              <td>{row.exit_time ? formatDate(row.exit_time) : '-'}</td>
                                                <td>{row.average_visit_duration_minutes || '-'}</td>

                                                <td>
                                                    {row.google_map_link ? (
                                                        <a
                                                            href={row.google_map_link}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            View Map
                                                        </a>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </td>

                                                {/* <td>{row.poi_category || '-'}</td> */}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="13" className="text-center">
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                </table>
                                {(poiPagination.raw_history_count || 0) > 10 && (
                                  <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                                      <button
                                          className="btn btn-secondary"
                                          disabled={(poiPagination.current_page || 1) <= 1}
                                          onClick={() => fetchPOIData((poiPagination.current_page || 1) - 1)}
                                      >
                                          Previous
                                      </button>

                                      <span>
                                          Page {poiPagination.current_page || 1} of {poiPagination.raw_history_pages || 1}
                                      </span>

                                      <button
                                          className="btn btn-primary"
                                          disabled={(poiPagination.current_page || 1) >= (poiPagination.raw_history_pages || 1)}
                                          onClick={() => fetchPOIData((poiPagination.current_page || 1) + 1)}
                                      >
                                          Next
                                      </button>
                                  </div>
                              )}
                            </div>
                        </div>
                    </div>

                    {/* Multi Visit */}
                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#multiVisit"
                            >
                                Multi Visit
                            </button>
                        </h2>

                        <div
                            id="multiVisit"
                            className="accordion-collapse collapse"
                        >
                            <div
                                className="accordion-body"
                                style={{
                                    overflowX: 'auto',
                                    width: '100%',
                                    padding: '15px'
                                }}
                                                        >

                                                            <table
                                className="table table-bordered table-striped"
                                style={{
                                    minWidth: '2400px',
                                    whiteSpace: 'nowrap',
                                    marginBottom: 0
                                }}
                            >
                                    <thead>
                                        <tr>
                                            {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Chassis Number</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Registration Number</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Loan Number</th> */}
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Manufacturer</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >POI ID</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Latitude</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Longitude</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Record Date</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Average Visit Duration Minutes</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Google Map Link</th>
                                            {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >POI Category</th> */}
                                        </tr>
                                    </thead>

                                    <tbody>
                                      {multiVisitData && multiVisitData.length > 0 ? (
                                          multiVisitData.map((row, index) => (
                                              <tr key={index}>
                                                  {/* <td>{row.chassis_number || '-'}</td>
                                                  <td>{row.registration_number || '-'}</td>
                                                  <td>{row.loan_number || '-'}</td> */}
                                                  <td>{row.manufacturer || '-'}</td>
                                                  <td>{row.poi_id || '-'}</td>
                                                  <td>{row.latitude || '-'}</td>
                                                  <td>{row.longitude || '-'}</td>
                                                  <td>{row.record_date ? formatDate(row.record_date) : '-'}</td>
                                                  <td>{row.average_visit_duration_minutes || '-'}</td>

                                                  <td>
                                                      {row.google_map_link ? (
                                                          <a
                                                              href={row.google_map_link}
                                                              target="_blank"
                                                              rel="noreferrer"
                                                          >
                                                              View Map
                                                          </a>
                                                      ) : (
                                                          '-'
                                                      )}
                                                  </td>

                                                  {/* <td>{row.poi_category || '-'}</td> */}
                                              </tr>
                                          ))
                                      ) : (
                                          <tr>
                                              <td colSpan="11" className="text-center">
                                                  No Data Found
                                              </td>
                                          </tr>
                                      )}
                                  </tbody>
                                </table>
                                 {multiVisitData.length >= 10 && (<div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                                    <button
                                        className="btn btn-secondary"
                                        disabled={(poiPagination.current_page || 1) <= 1}
                                        onClick={() => fetchPOIData((poiPagination.current_page || 1) - 1)}
                                    >
                                        Previous
                                    </button>

                                    <span>
                                        Page {poiPagination.current_page || 1} of {poiPagination.multi_visit_pages || 1}
                                    </span>

                                    <button
                                        className="btn btn-primary"
                                        disabled={(poiPagination.current_page || 1) >= (poiPagination.multi_visit_pages || 1)}
                                        onClick={() => fetchPOIData((poiPagination.current_page || 1) + 1)}
                                    >
                                        Next
                                    </button>
                                </div>)}
                            </div>
                        </div>
                    </div>

                    {/* Home Base */}
                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#homeBase"
                            >
                                Home Base
                            </button>
                        </h2>

                        <div
                            id="homeBase"
                            className="accordion-collapse collapse"
                        >
                            <div
                                className="accordion-body"
                                style={{
                                      overflowX: 'auto',
                                      width: '100%',
                                      padding: '15px'
                                  }}
                                                          >

                                                              <table
                                  className="table table-bordered table-striped"
                                  style={{
                                      minWidth: '2400px',
                                      whiteSpace: 'nowrap',
                                      marginBottom: 0
                                  }}
                              >
                                    <thead>
                                        <tr>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >POI ID</th>
                                            {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Chassis Number</th> */}
                                            {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Registration Number</th> */}
                                            {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Loan Number</th> */}
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Manufacturer</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Latitude</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Longitude</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Record Date</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Average Visit Duration Minutes</th>
                                            <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >Google Map Link</th>
                                            {/* <th
                                                  style={{
                                                      minWidth: '180px',
                                                      padding: '14px 18px',
                                                      textAlign: 'center',
                                                      verticalAlign: 'middle',
                                                      fontWeight: 600
                                                  }}
                                              >POI Category</th> */}
                                        </tr>
                                    </thead>

                                    <tbody>
                                      {homeBaseData && homeBaseData.length > 0 ? (
                                          homeBaseData.map((row, index) => (
                                              <tr key={index}>
                                                  <td>{row.poi_id || '-'}</td>
                                                  {/* <td>{row.chassis_number || '-'}</td>
                                                  <td>{row.registration_number || '-'}</td>
                                                  <td>{row.loan_number || '-'}</td> */}
                                                  <td>{row.manufacturer || '-'}</td>
                                                  <td>{row.latitude || '-'}</td>
                                                  <td>{row.longitude || '-'}</td>
                                                  <td>{row.record_date ? formatDate(row.record_date) : '-'}</td>
                                                  <td>{row.average_visit_duration_minutes || '-'}</td>

                                                  <td>
                                                      {row.google_map_link ? (
                                                          <a
                                                              href={row.google_map_link}
                                                              target="_blank"
                                                              rel="noreferrer"
                                                          >
                                                              View Map
                                                          </a>
                                                      ) : (
                                                          '-'
                                                      )}
                                                  </td>

                                                  {/* <td>{row.poi_category || '-'}</td> */}
                                              </tr>
                                          ))
                                      ) : (
                                          <tr>
                                              <td colSpan="11" className="text-center">
                                                  No Data Found
                                              </td>
                                          </tr>
                                      )}
                                  </tbody>
                                </table>
                                 {homeBaseData.length >= 10 && (<div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                                    <button
                                        className="btn btn-secondary"
                                        disabled={(poiPagination.current_page || 1) <= 1}
                                        onClick={() => fetchPOIData((poiPagination.current_page || 1) - 1)}
                                    >
                                        Previous
                                    </button>

                                    <span>
                                        Page {poiPagination.current_page || 1} of {poiPagination.home_base_pages || 1}
                                    </span>

                                    <button
                                        className="btn btn-primary"
                                        disabled={(poiPagination.current_page || 1) >= (poiPagination.home_base_pages || 1)}
                                        onClick={() => fetchPOIData((poiPagination.current_page || 1) + 1)}
                                    >
                                        Next
                                    </button>
                                </div>)}
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

      {activeTabName === 'km_run_history' && (
          <KmRunHistoryByAgreement agreementNo={vitem?.AgreementNo} />
      )}

        <div className={activeTabName === 'additional' ? 'tab-pane fade show active' : 'tab-pane fade'} id="pills-additional" role="tabpanel">
          <div className='mb-4 px-4'>
            <div id='main-wrap' className='mb-4 px-4'>
              <h5 className='fw-bold mb-3'>Additional Data and Information</h5>
              <div className='row'>
                <div className='col-md-12'>
                  <form onSubmit={handleSubmit(onSubmit)} className="row" encType="multipart/form-data">
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="residence_status">
                          <span>Residence Status</span>
                          <select name='residence_status' className="form-select" {...register('residence_status')}
                            value={formValues.residence_status}
                            onChange={handleChange}
                          >
                            <option value="">Select Residence Status</option>
                            {allResidenceStatusMaster.length > 0 && allResidenceStatusMaster.map((option) => (
                                <option value={option.name}>
                                    {option.name}
                                </option>
                            ))}
                          </select>
                        </label>
                        {errors.residence_status && <span className="required">This field is required.</span>}
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="profile">
                          <span>Profile</span>
                          <select name='profile' className="form-select" {...register('profile')} 
                            value={formValues.profile}
                            onChange={handleChange}
                          >
                            <option value="">Select Profile</option>
                            {allProfileMaster.length > 0 && allProfileMaster.map((option) => (
                                <option value={option.name}>
                                    {option.name}
                                </option>
                            ))}
                          </select>
                        </label>
                        {errors.profile && <span className="required">This field is required.</span>}
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="msme">
                          <span>MSME</span>
                          <input type='text' name='msme' className='form-control' {...register('msme')}
                            value={formValues.msme}
                            onChange={handleChange}
                          />
                        </label>
                        {errors.msme && <span className="required">This field is required.</span>}
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="insurance_validity_date">
                          <span>Insurance Validity Date</span>
                          <input type="date" id="insurance_validity_date" name="insurance_validity_date" className="form-control" {...register('insurance_validity_date')} />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="sanction_date">
                          <span>Sanction Date</span>
                          <input type="date" id="sanction_date" name="sanction_date" className="form-control" {...register('sanction_date')} />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="stability">
                          <span>Stability</span>
                          <input type='text' name='stability' className='form-control' {...register('stability')}
                            value={formValues.stability}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="sector_of_unit">
                          <span>Sector of Unit</span>
                          <select name='sector_of_unit' className="form-select" {...register('sector_of_unit')}
                            value={formValues.sector_of_unit}
                            onChange={handleChange}
                          >
                            <option value="">Select Sector of Unit</option>
                            {allSectorOfUnitMaster.length > 0 && allSectorOfUnitMaster.map((option) => (
                                <option value={option.name}>
                                    {option.name}
                                </option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="sub_sector">
                          <span>Sub Sector</span>
                          <input type='text' name='sub_sector' className='form-control' {...register('sub_sector')} 
                            value={formValues.sub_sector}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="business_of_occupation">
                          <span>Business of Occupation</span>
                          <input type='text' name='business_of_occupation' className='form-control' {...register('business_of_occupation')}
                            value={formValues.business_of_occupation}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="turnover">
                          <span>Turnover</span>
                          <input type='text' name='turnover' className='form-control' {...register('turnover')}
                            value={formValues.turnover}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="dl_number">
                          <span>DL Number</span>
                          <input type='text' name='dl_number' className='form-control' {...register('dl_number')}
                            value={formValues.dl_number}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="dl_status">
                          <span>DL Status</span>
                          <select name='dl_status' className="form-select" {...register('dl_status')}
                            value={formValues.dl_status}
                            onChange={handleChange}
                          >
                            <option value="">Select DL Status</option>
                            {allDlStatusMaster.length > 0 && allDlStatusMaster.map((option) => (
                                <option value={option.name}>
                                    {option.name}
                                </option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="category">
                          <span>Category</span>
                          <select name='category' className="form-select" {...register('category')}
                            value={formValues.category}
                            onChange={handleChange}
                          >
                            <option value="">Select Category</option>
                            {allCategoryMaster.length > 0 && allCategoryMaster.map((option) => (
                                <option value={option.name}>
                                    {option.name}
                                </option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="region">
                          <span>Region</span>
                          <select name='region' className="form-select" {...register('region')}
                            value={formValues.region}
                            onChange={handleChange}
                          >
                            <option value="">Select Region</option>
                            {allRegionMaster.length > 0 && allRegionMaster.map((option) => (
                                <option value={option.name}>
                                    {option.name}
                                </option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="city_stability">
                          <span>City Stability</span>
                          <input type='text' name='city_stability' className='form-control' {...register('city_stability')}
                            value={formValues.city_stability}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="residence_stability">
                          <span>Residence Stability</span>
                          <input type='text' name='residence_stability' className='form-control' {...register('residence_stability')}
                            value={formValues.residence_stability}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="business_stability">
                          <span>Business Stability</span>
                          <input type='text' name='business_stability' className='form-control' {...register('business_stability')}
                            value={formValues.business_stability}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="driving_experience">
                          <span>Driving Experience</span>
                          <input type='text' name='driving_experience' className='form-control' {...register('driving_experience')}
                            value={formValues.driving_experience}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="product">
                          <span>Product</span>
                          <select name='product' className="form-select" {...register('product')}
                            value={formValues.product}
                            onChange={handleChange}
                          >
                            <option value="">Select Product</option>
                            {allProductMaster.length > 0 && allProductMaster.map((option) => (
                                <option value={option.name}>
                                    {option.name}
                                </option>
                            ))}
                          </select>
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="relation_with_applicant">
                          <span>Relation With Applicant</span>
                          <input type='text' name='relation_with_applicant' className='form-control' {...register('relation_with_applicant')}
                            value={formValues.relation_with_applicant}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="battery_number">
                          <span>Battery Number</span>
                          <input type='text' name='battery_number' className='form-control' {...register('battery_number')}
                            value={formValues.battery_number}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label htmlFor="deployment_of_asset">
                          <span>Deployment of the Asset</span>
                          <input type='text' name='deployment_of_asset' className='form-control' {...register('deployment_of_asset')}
                            value={formValues.deployment_of_asset}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-12'>
                      <div className='form-group'>
                        <label htmlFor="query">
                          <span>Warranty Details</span>
                          <textarea id='warranty_detail' name='warranty_detail' className='form-control' {...register('warranty_detail')}
                            value={formValues.warranty_detail}
                            onChange={handleChange}
                          />
                        </label>
                      </div>
                    </div>

                    <div className='col-md-12'>
                      <div className='form-group mb-2'>
                        <button type="submit" className='btn btn-primary'>Submit</button>
                      </div>
                    </div>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>

         <div className={activeTabName === 'payment_documents' ? 'tab-pane fade show active' : 'tab-pane fade'} id="pills-payment_documents" role="tabpanel">
          <div className='mb-4 px-4'>
            <div id='main-wrap' className='mb-4 px-4'>
              <h5 className='fw-bold mb-3'>Payment Documents</h5>
              <div className='row'>
                <div className='col-md-12'>
                      <div id="main-wrap" className='mt-4'>
                                      <div className="table-wrap">
                                          <table className="table table-hover">
                                              <thead>
                                                  <tr>
                                                      <th>Document ID</th>
                                                      <th>Created Date</th>
                                                      <th>Created By</th>
                                                      <th>View Document</th>
                                                  </tr>
                                              </thead>
                      
                                              {paginatedItems.length === 0 ? (
                                                  <tbody>
                                                      <tr>
                                                          <td colSpan="4" style={{ textAlign: 'center' }}>
                                                              <h5>No Document</h5>
                                                          </td>
                                                      </tr>
                                                  </tbody>
                                              ) : (
                                                  <tbody>
                                                      {paginatedItems.map((item, index) => (
                                                          <tr key={index}>
                                                              <td>{item.formatetdID}</td>
                                                              <td>{item.created_date}</td>
                                                              <td>{item.createdByName}</td>
                                                              
                                                              <td>
                                                                  <a target="new" href={item.file} className='text-decoration-none'>
                                                                      <i className="bi bi-eye"/>
                                                                  </a>
                                                              </td>
                                                          </tr>
                                                      ))}
                                                  </tbody>
                                              )}
                                          </table>
                                      </div>
                      
                                      <div>
                                          <nav className='mb-1'>
                                              <ul className="pagination pagination-md justify-content-end">
                                                  {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                                                      <li className="page-item">
                                                          <button
                                                              key={page}
                                                              onClick={() => handlePageChange(page)}
                                                              disabled={currentPage === page}
                                                              className="page-link"
                                                          >
                                                              {page}
                                                          </button>
                                                      </li>
                                                  ))}
                                              </ul>
                                          </nav>
                                      </div>
                                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
  
        {activeTabName === 'phone_history' && (
          <div className="card mt-3">
              <div className="card-header">
                  <h5 className="mb-0">Phone Number History</h5>
              </div>

              <div className="card-body">

                  {phoneHistoryLoader && (
                      <div>Loading...</div>
                  )}

                  {!phoneHistoryLoader && !phoneHistory && (
                      <div className="alert alert-warning">
                          No Phone History Found
                      </div>
                  )}

                  {!phoneHistoryLoader && phoneHistory && (
                      <>
                          <div className="row">

                              <div className="col-md-6">
                                  <h6 className="fw-bold text-danger mb-3">
                                      Old Phone Numbers
                                  </h6>

                                  <table className="table table-bordered">
                                      <tbody>
                                          <tr>
                                              <th>Old Phone 1</th>
                                              <td>{phoneHistory.old_phone_1 || '-'}</td>
                                          </tr>

                                          <tr>
                                              <th>Old Phone 2</th>
                                              <td>{phoneHistory.old_phone_2 || '-'}</td>
                                          </tr>

                                          <tr>
                                              <th>Old Phone 3</th>
                                              <td>{phoneHistory.old_phone_3 || '-'}</td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>

                              <div className="col-md-6">
                                  <h6 className="fw-bold text-success mb-3">
                                      New Phone Numbers
                                  </h6>

                                  <table className="table table-bordered">
                                      <tbody>
                                          <tr>
                                              <th>New Phone 1</th>
                                              <td>{phoneHistory.new_phone_1 || '-'}</td>
                                          </tr>

                                          <tr>
                                              <th>New Phone 2</th>
                                              <td>{phoneHistory.new_phone_2 || '-'}</td>
                                          </tr>

                                          <tr>
                                              <th>New Phone 3</th>
                                              <td>{phoneHistory.new_phone_3 || '-'}</td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>

                          </div>
                      </>
                  )}

              </div>
          </div>
      )}

         <div className={activeTabName === 'vehicle_inspection_form' ? 'tab-pane fade show active' : 'tab-pane fade'} id="pills-vehicle_inspection_form" role="tabpanel">
          <div className='mb-4- px-4-'>
            <div id='main-wrap' className='mb-4- px-4-'>
              
              <div className='row'>
                <div className='col-md-12'>
                  <h5 className='fw-bold mb-3'>Short Inspection History</h5>                                  
                  <FiDetils
                      props={props}
                      pageTitle= ""
                      allFiSaveHistory={allFiSaveHistory}
                      leadId={leadID}
                      camLatestStatus={camLatestStatus}
                      setSectionName="vehicle_inspection_form"
                      AgreementNo = {vitem.AgreementNo}
                    /> 
                    <br/>
                    <hr/>
                     <br/>
                    <h5 className='fw-bold mb-3'>Short Inspection Form</h5>    
                               {!open  ? (

                                <>
                                    <LeadChecklists
                                      props={props}
                                      allLeadCheckLists={allLeadCheckLists}
                                      setOpen={setOpen}
                                      setViewModalInfo={setViewModalInfo}
                                      setQuestions={setQuestions}
                                      setOpenQue={setOpenQue}
                                      userRoleType={userRoleType}
                                      creditAllLeadCheckLists={creditAllLeadCheckLists}
                                      leadStatusFlag={leadStatusFlag}
                                      setSectionName="vehicle_inspection_form"
                                      camLatestStatus={camLatestStatus}
                                      AgreementNo = {vitem.AgreementNo}
                                    />

                                    
                                    </>
                                  ) : (
                                    <>
                                     
                                      <LeadQuestionnaire
                                        questions={questions}
                                        checklistInfo={viewModalInfo}
                                        props={props}
                                        setOpen={setOpen}
                                        fetchLeads={fetchLeads}
                                        updateParentState={updateParentState}
                                        userRoleType={userRoleType}
                                        scoreCard={scoreCard}
                                        leadStatusFlag={leadStatusFlag}
                                        setSectionName="vehicle_inspection_form"
                                        camLatestStatus={camLatestStatus}
                                        AgreementNo = {vitem.AgreementNo}
                                      />
                                    </>
                                  )} 


                            
                      
                  </div>
              </div>
            </div>
          </div>
        </div>


        <div className={activeTabName === 'legal_actions' ? 'tab-pane fade show active' : 'tab-pane fade'} id="pills-legal_actions" role="tabpanel">
          <div className='mb-4- px-4-'>
            <div id='main-wrap' className='mb-4- px-4-'>
              
              <div className='row'>
                <div className='col-md-12'>
                  <h5 className='fw-bold mb-3'>Legal Actions</h5>                                  
                   
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div className={activeTabName === 'no_objection_certificate' ? 'tab-pane fade show active' : 'tab-pane fade'} id="pills-no_objection_certificate" role="tabpanel">
          <div className='mb-4- px-4-'>
            <div id='main-wrap' className='mb-4- px-4-'>
              
              <div className='row'>
                <div className='col-md-12'>
                  <h5 className='fw-bold mb-3'>No Objection Certificate</h5> 

                  { (vitem.StatusId !== "Completed" && vitem.StatusId !== 'Settled' ) ? ( 

                    <>
                      <div className='text-danger'>This agreement is not eligible for No objection certificate.</div> 
                    </>
                   ) : ( 
                  <>
                  <div ref={printRef}>
                    <div style={{ padding: "10px" }}>&nbsp;</div>
                    <div className= "noObjectionCertificate"> 

<table style={{ border: '1px',width:'100%' }}>
    <tr>       
    
      <td>Date: { ( enableUpdatePdfDetails) ? (
                            <>
                             <input
                                type="date"  
                                id="refDate" 
                                name="refDate" 
                                style={{ width: 'auto' }}
                                className='form-control' {...register('refDate')} 
                                value={refDate} 
                                onChange={handleFormChange} 
                             /> 
                            </>
                        ) : (
                            <>
                             {refDate} 
                            </>
                        )}</td>							
      <td align='right'>Reference No. { ( enableUpdatePdfDetails) ? (
                            <>
                             <input
                                type="text"  
                                id="refNo" 
                                name="refNo" 
                                style={{ width: 'auto' }}
                                className='form-control' {...register('refNo')} 
                                value={refNo} 
                                onChange={handleFormChange} 
                             /> 
                            </>
                        ) : (
                            <>
                             <strong>{refNo}&nbsp;</strong> 
                            </>
                        )}</td>
    </tr>
    <tr>
<td colSpan="2"><br/>
To, <br/>
The Regional Transport Authority, <br/>
{ ( enableUpdatePdfDetails) ? (
                            <>
                             <input
                                type="text"  
                                id="regionalTransportAuthority" 
                                name="regionalTransportAuthority" 
                                style={{ width: 'auto' }}
                                className='form-control' {...register('regionalTransportAuthority')} 
                                value={regionalTransportAuthority} 
                                onChange={handleFormChange} 
                             /> 
                            </>
                        ) : (
                            <>
                             <strong>{regionalTransportAuthority}&nbsp;</strong> 
                            </>
                        )}<br/><br/>

<strong>Subject:</strong> Have <strong>“No Objection”</strong> for Cancellation of Hypothecation in respect of vehicle no:  <strong>{vehicleNo}&nbsp;</strong><br/><br/>
Dear Sir/Ma'am<br/><br/>
I/we hereby declare that to the best of my / our knowledge the registration of the vehicles has not been suspend or cancelled under the provisions of the Act or rules made there under and the circumstances explained above are true.<br/><br/>


I/we wish to inform you that we have received payment in full settlement towards the Hypothecation agreement of Motor Vehicle No. <strong>{vehicleNo}&nbsp;</strong> Owner <strong>{ownerName}&nbsp;</strong><br/><br/>

I/ we have no objection for the cancellation of that Hypothecation made in our favor on the Registration Certificate of the above said vehicle. We also forward here with the form NO. 35 in duplicate duly completed by us.<br/><br/>

So, kindly do the needful and obliged<br/><br/>
Thank You,<br/>
Yours Faithfully<br/><br/>
<strong>For cKers Finance Private Limited</strong><br/><br/><br/><br/>


<strong>Authorized Signatory</strong>
</td>
</tr>
</table>
                      </div>                                
                   </div> 
 <br/> 
    {( isReadyToModify && (userRoleType !== "" || userRoleType === 'Credit' || userRoleType === 'Superadmin')) ? (
      <>

        { savedApplicationDetailsInfo?.action_status  === '1' ? ( <> 
          { ( !enableUpdatePdfDetails) && (
              <>
              
          <button className='btn btn-warning text-white float-right-' onClick={handleDownloadPdf}>Generate PDF
          {preloaderStatus && (
              <>
                <div
                  className="spinner-border small-preloader"
                  role="status"
                >
                  <span className="visually-hidden">
                    {" "}
                    Loading...
                  </span>
                </div>
              </>
            )}
          </button>  
          
            </>
          )}
        </> ) :
        (
          <>
          { ( !enableUpdatePdfDetails) ? (
          <button type="button" className="btn btn-primary text-white" onClick={handleToggleUpdateDetails} >Update Details</button>
          ) : (
              <>
              <button type="button" className="btn btn-primary text-white" onClick={handleToggleSaveDetails} >Save Details</button>

              &nbsp;<button type="button" className="btn btn-danger text-white" onClick={handleToggleUpdateDetails} >Cancel</button>
              </>
          )}

          { ( !enableUpdatePdfDetails) && (
          <>
            <button className='btn btn-warning text-white float-right' onClick={handleDownloadPdf}>Generate PDF {preloaderStatus && (
              <>
                <div
                  className="spinner-border small-preloader"
                  role="status"
                >
                  <span className="visually-hidden">
                    {" "}
                    Loading...
                  </span>
                </div>
              </>
            )}</button>
            
          </>
          )}

          </>
      )}

          { (savedApplicationDetailsInfo?.action_status  > 0  && savedApplicationDetailsInfo?.action_status  < 3) && ( 
              <> 
                &nbsp;
              </>
            )} 


            <div>
            { latestDownloadedByName !=='' && (
              <>
                <div className="text-end text-green">Last downloaded by {latestDownloadedByName} on { latestDownloadedDateFormat}</div>
              </>

            )}
            </div>
          </>

      ) : (
          <></>
      )} 


          { ( isReadyToModify && (userRoleType !== "" || userRoleType === 'Credit Head' || userRoleType === 'Superadmin' ) && refNo !=='' ) ? (
            
            <>
                &nbsp;

              
              </>
            
          ) : (
            <>
            
              &nbsp;
            </>
        )}


      { showSanctionNote !== ""   && (
          <div className={sanctionApproveLatestStatus=== '0' ? "text-end text-primary" : ( sanctionApproveLatestStatus=== '1' ? "text-end text-success" : "text-end text-red" )}>{showSanctionNote}</div>
          )}  


              </>)}
                  </div>

              </div>
            </div>
          </div>
        </div>

        {/* Due Reminder Notice Tab Content */}
       
        {vitem?._isDueReminderNoticeEnabled && (
          <div className={activeTabName === 'due_reminder_notice' ? 'tab-pane fade show active' : 'tab-pane fade'} id="pills-due_reminder_notice" role="tabpanel">
            <div className='mb-4 px-4'>
              <div id='due-reminder-main-wrap' className='mb-4'>
                <div className='row'>
                  <div className='col-md-12'>
                    <h5 className='fw-bold mb-3'>Due Reminder Notice</h5>

                    {dueReminderSubTabs.length === 0 ? (
                      <div className="alert alert-info">
                        No borrower data available. Please check if lstCoBorrowers is populated.
                      </div>
                    ) : (
                      <>
                    {/* Sub-tabs for different borrower types */}
                    <ul className="nav nav-pills mb-4" id="due-reminder-subtabs" role="tablist">
                      {dueReminderSubTabs.map((subTab, index) => (
                        <li className="nav-item" role="presentation" key={subTab.id}>
                          <button
                            className={dueReminderActiveTab === subTab.id ? "nav-link active" : "nav-link"}
                            id={`due-reminder-${subTab.id}-tab`}
                            data-bs-toggle="pill"
                            data-bs-target={`#due-reminder-${subTab.id}`}
                            type="button"
                            role="tab"
                            aria-controls={`due-reminder-${subTab.id}`}
                            aria-selected={dueReminderActiveTab === subTab.id ? "true" : "false"}
                            onClick={() => setDueReminderActiveTab(subTab.id)}
                          >
                            {subTab.label}
                          </button>
                        </li>
                      ))}
                    </ul>

                    {/* Sub-tab Content */}
                    <div className="tab-content" id="due-reminder-subtabs-content">
                      {dueReminderSubTabs.map((subTab) => (
                        <div
                          key={subTab.id}
                          className={dueReminderActiveTab === subTab.id ? 'tab-pane fade show active' : 'tab-pane fade'}
                          id={`due-reminder-${subTab.id}`}
                          role="tabpanel"
                        >
                          {/* Action Buttons */}
                          <div className='mb-3 text-end'>
                            <button
                              className='btn btn-info text-white me-2'
                              onClick={() => {
                                const previewElement = document.getElementById(`due-reminder-preview-${subTab.id}`);
                                if (previewElement) {
                                  previewElement.scrollIntoView({ behavior: 'smooth' });
                                }
                              }}
                            >
                              Preview
                            </button>
                            <button
                              className='btn btn-warning text-white'
                              onClick={() => handleDueReminderDownloadPdf(subTab.type, subTab.borrower.CustomerId, subTab.borrower.BorrowerName, subTab.id)}
                              disabled={dueReminderPreloader}
                            >
                              Download PDF
                              {dueReminderPreloader && (
                                <div className="spinner-border small-preloader ms-2" role="status" />
                              )}
                            </button>
                          </div>

                          {/* Download History */}
                          {dueReminderDownloadHistory[`${subTab.type}-${subTab.borrower.CustomerId}`]?.downloadedBy && (
                            <div className="text-end text-success mb-3">
                              Last downloaded by {dueReminderDownloadHistory[`${subTab.type}-${subTab.borrower.CustomerId}`].downloadedBy} on {dueReminderDownloadHistory[`${subTab.type}-${subTab.borrower.CustomerId}`].downloadedDate}
                            </div>
                          )}

                          {/* Letter Preview */}
                          <div id={`due-reminder-preview-${subTab.id}`}>
                            <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", backgroundColor: "white" }}>

                              {/* Company Header - Dynamic based on Agreement Number */}
                              {(() => {
                                const companyDetails = getCompanyDetails(vitem?.AgreementNo);
                                return (
                                  <div style={{ textAlign: "center", marginBottom: "20px" }}>

                                     <img 
                                      src={`/assets/${companyDetails.logo || 'ckern-logo.png'}`} 
                                      className="login-logo-" 
                                      alt="Company Logo" 
                                      style={{ display: "block", margin: "0 auto" ,paddingBottom: "20px"  }} 
                                    />


                                    <h3 style={{ color: "#ff6600", marginBottom: "5px" }}>{companyDetails.name}</h3>
                                    <p style={{ fontSize: "12px", margin: "0" }}>{companyDetails.address}</p>
                                    {companyDetails.hasContact && (
                                      <p style={{ fontSize: "12px", margin: "0" }}>{companyDetails.contact}</p>
                                    )}
                                  </div>
                                );
                              })()}

                              {/* Letter Type Header */}
                              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                                <h5 style={{ fontWeight: "bold" }}>
                                  {subTab.type === 'applicant' && 'Due Reminder Letter'}
                                  {subTab.type === 'co-applicant' && 'Due Reminder Letter To Co-Applicant'}
                                  {subTab.type === 'guarantor' && 'Due Reminder Letter To Guarantor'}
                                </h5>
                              </div>

                              {/* Recipient Information */}
                              <div style={{ marginBottom: "20px" }}>
                                <p style={{ marginBottom: "5px" }}><strong>To,</strong></p>
                                <p style={{ marginBottom: "5px" }}><strong>{subTab.borrower.BorrowerName}</strong></p>
                                <p style={{ fontSize: "14px", marginBottom: "5px" }}>
                                  Address: {getBorrowerAddress(
                                    subTab.borrower.BorrowerName,
                                    subTab.type,
                                    allLmsCoApplicants,
                                    allLmsGuarantors,
                                    vitem?.applicant_full_address
                                  )}
                                </p>
                              </div>

                              {/* Reference/Loan Information - Different format for Applicant vs Co-applicant/Guarantor */}
                              {subTab.type === 'applicant' ? (
                                // Applicant: Show loan details directly without "Reference:" label
                                <p style={{ marginBottom: "5px" }}>
                                    <strong>Vehicle No:</strong> {vitem?.recordsVehicle?.[0]?.RegistrationNo || '-'}
                                  </p>
                              ) : (
                                // Co-applicant & Guarantor: Show "Reference:" with primary applicant name
                                <div style={{ marginBottom: "20px" }}>
                                  <p style={{ marginBottom: "5px" }}>
                                    <strong>Reference:</strong> {vitem?.CustomerName || '-'}
                                  </p>
                                  <p style={{ marginBottom: "5px" }}>
                                    <strong>Vehicle No:</strong> {vitem?.recordsVehicle?.[0]?.RegistrationNo || '-'}
                                  </p>
                                  <p style={{ marginBottom: "5px" }}>
                                    <strong>Model:</strong> {vitem?.cam_vehicle_models || '-'}
                                  </p>
                                  <p style={{ marginBottom: "5px" }}>
                                    <strong>Over Due Amount:</strong> ₹{vitem?.TotalLoanOverdueAmount || '-'}/-
                                  </p>
                                </div>
                              )}

                              {/* Letter Body */}
                              {subTab.type === 'applicant' && (
                                <>
                                <div style={{ marginBottom: "20px", fontSize: "14px", lineHeight: "1.6" }}>
                                  <p>यह पत्र आपको सूचित करने हेतु जारी किया जा रहा है कि आपके ऋण खाते में ₹{vitem?.TotalLoanOverdueAmount || '-'}/- (रुपये {convertAmountToWords(vitem?.TotalLoanOverdueAmount)} मात्र) की राशि बकाया है। कृपया उक्त राशि का भुगतान अविलंब सुनिश्चित करें।</p>
                                  <p> 

                                    कृपया डिमांड ड्राफ्ट /RTGS/ UPI/ NEFT/ /चेक द्वारा भुगतान कर सकते है(बैंक: {vitem?.accountBranch || 'ICICI Bank'}, शाखा, दिल्ली, खाता संख्या: {vitem?.accountNo || '182005001431'}). कृपया जमा की गई राशि को वाहन नंबर और जमा की तारीख का उल्लेख करते हुए मोबाइल नंबर {vitem?.supportNumber || '88882247464'} पर सूचित करें। समझौते के नियमों और शर्तों के अनुसार, संग्रह शुल्क तथा विलंबित भुगतान पर अतिरिक्त शुल्क और अन्य शुल्क अलग से लिए जाएंगे।

                                  </p>

                                </div>
                                {/* Applicant: Show loan details directly without "Reference:" label */}
                                <div style={{ marginBottom: "20px" }}>
                                 
                                  <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                                    <tbody>
                                      <tr style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '8px', fontWeight: 'bold' }}>Agreement No</td>
                                        <td style={{ padding: '8px' }}>{vitem?.AgreementNo || '-'}</td>
                                      </tr>
                                      <tr style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '8px', fontWeight: 'bold' }}>Registration Number</td>
                                        <td style={{ padding: '8px' }}>{vitem?.recordsVehicle?.[0]?.RegistrationNo || '-'}</td>
                                      </tr>
                                      <tr style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '8px', fontWeight: 'bold' }}>Model</td>
                                        <td style={{ padding: '8px' }}>{vitem?.cam_vehicle_models || '-'}</td>
                                      </tr>
                                      <tr style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '8px', fontWeight: 'bold' }}>Agreement Date</td>
                                        <td style={{ padding: '8px' }}>{formatDateToDDMMYYYY(vitem?.StartDate)}</td>
                                      </tr>
                                      <tr style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '8px', fontWeight: 'bold' }}>Total Number of EMI Dues</td>
                                        <td style={{ padding: '8px' }}>{vitem?.TotalNumberofEMIDues || '-'}</td>
                                      </tr>
                                      <tr style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '8px', fontWeight: 'bold' }}>Instalment Amount</td>
                                        <td style={{ padding: '8px' }}>₹{vitem?.instalmentAmount || '-'}</td>
                                      </tr>
                                      <tr style={{ borderBottom: '1px solid #ddd' }}>
                                        <td style={{ padding: '8px', fontWeight: 'bold' }}>Last Receipt Date</td>
                                        <td style={{ padding: '8px' }}>{formatDateToDDMMYYYY(vitem?.lastReceiptDate)}</td>
                                      </tr>
                                      <tr>
                                        <td style={{ padding: '8px', fontWeight: 'bold' }}>Total Dues</td>
                                        <td style={{ padding: '8px' }}>₹{vitem?.TotalLoanOverdueAmount || '-'}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                               
                              <div style={{ marginBottom: "20px", fontSize: "14px", lineHeight: "1.6" }}>
                                  <p>आपसे अनुरोध है कि कृपया इस पत्र की प्राप्ति की तिथि से तीन (3) दिनों के भीतर उपरोक्त बकाया राशि का भुगतान करें अथवा किसी भी कार्यदिवस में प्रातः 09:30 बजे से सायं 06:30 बजे तक हमारे कार्यालय से संपर्क कर भुगतान की संभावित तिथि की जानकारी प्रदान करें।</p>
                                  <p>कृपया ध्यान दें कि यदि निर्धारित अवधि में EMI अथवा अन्य देय राशि का भुगतान नहीं किया जाता है, तो RBI के प्रचलित दिशानिर्देशों के अनुसार आपके ऋण खाते की लंबित राशि को क्रेडिट ब्यूरो में रिपोर्ट किया जा सकता है तथा ऋण समझौते एवं लागू कानूनों के अंतर्गत अन्य आवश्यक कार्रवाई की जा सकती है।</p>
                                  <p style={{ fontStyle: "italic" }}>यदि भुगतान पहले ही किया जा चुका है, तो कृपया इस पत्र को अनदेखा करें।</p>
                                </div>
                                </>
                              )} 

                              {subTab.type === 'co-applicant' && (
                                <div style={{ marginBottom: "20px", fontSize: "14px", lineHeight: "1.6" }}>
                                  <p>यह पत्र आपको सूचित करने हेतु जारी किया जा रहा है कि उपरोक्त संदर्भित ऋण खाते में ₹{vitem?.TotalLoanOverdueAmount || '-'}/- (रुपये {convertAmountToWords(vitem?.TotalLoanOverdueAmount)} मात्र) की राशि बकाया है, जिसमें आप सह-आवेदक के रूप में सम्मिलित हैं।</p>
                                  <p>हम यह स्पष्ट करना चाहते हैं कि मुख्य आवेदक को पहले ही बकाया राशि के संबंध में, साथ ही संग्रह शुल्क, विलंब शुल्क एवं अन्य लागू शुल्क, जो कि ऋण समझौते की शर्तों एवं नियमों के अनुसार देय हैं, के बारे में सूचित किया जा चुका है। तथापि, आज की तिथि तक उक्त बकाया राशि के विरुद्ध कोई भी EMI अथवा भुगतान प्राप्त नहीं हुआ है, न ही आवेदक द्वारा भुगतान के संबंध में हमारे कार्यालय से संपर्क किया गया है।</p>
                                  <p>अतः आपसे अनुरोध है कि कृपया सुनिश्चित करें कि उपरोक्त बकाया राशि इस पत्र की प्राप्ति की तिथि से तीन (3) दिनों के भीतर जमा कर दी जाए। वैकल्पिक रूप से, आप अथवा आवेदक किसी भी कार्यदिवस में प्रातः 09:30 बजे से सायं 06:30 बजे तक हमारे कार्यालय से संपर्क कर भुगतान की संभावित तिथि अथवा पुनर्भुगतान व्यवस्था के संबंध में चर्चा कर सकते हैं।</p>
                                  <p>कृपया ध्यान दें कि यदि निर्धारित अवधि में EMI अथवा अन्य देय शुल्कों का भुगतान नहीं किया जाता है, तो प्रचलित नियमों एवं दिशानिर्देशों के अनुसार, आवेदक, गारंटर एवं सह-आवेदक के क्रेडिट ब्यूरो अभिलेखों में बकाया राशि की रिपोर्टिंग की जाएगी तथा ऋण समझौते एवं लागू कानूनों के अंतर्गत अन्य आवश्यक कार्रवाई की जा सकती है।</p>
                                  <p style={{ fontStyle: "italic" }}>यदि उक्त राशि का भुगतान पहले ही किया जा चुका है, तो कृपया इस पत्र को अनदेखा करें।</p>
                                </div>
                              )}

                              {subTab.type === 'guarantor' && (
                                <div style={{ marginBottom: "20px", fontSize: "14px", lineHeight: "1.6" }}>
                                  <p>यह पत्र आपको सूचित करने हेतु जारी किया जा रहा है कि उपरोक्त संदर्भित ऋण खाते में ₹{vitem?.TotalLoanOverdueAmount || '-'}/- (रुपये {convertAmountToWords(vitem?.TotalLoanOverdueAmount)} मात्र) की राशि बकाया है, जिसमें आप गारंटर के रूप में सम्मिलित हैं।</p>
                                  <p>हम यह स्पष्ट करना चाहते हैं कि मुख्य आवेदक को पहले ही बकाया राशि के संबंध में, साथ ही संग्रह शुल्क, विलंब शुल्क एवं अन्य लागू शुल्क, जो कि ऋण समझौते की शर्तों एवं नियमों के अनुसार देय हैं, के बारे में सूचित किया जा चुका है। तथापि, आज की तिथि तक उक्त बकाया राशि के विरुद्ध कोई भी EMI अथवा भुगतान प्राप्त नहीं हुआ है, न ही आवेदक द्वारा भुगतान के संबंध में हमारे कार्यालय से संपर्क किया गया है।</p>
                                  <p>अतः आपसे अनुरोध है कि कृपया सुनिश्चित करें कि उपरोक्त बकाया राशि इस पत्र की प्राप्ति की तिथि से तीन (3) दिनों के भीतर जमा कर दी जाए। वैकल्पिक रूप से, आप अथवा आवेदक किसी भी कार्यदिवस में प्रातः 09:30 बजे से सायं 06:30 बजे तक हमारे कार्यालय से संपर्क कर भुगतान की संभावित तिथि अथवा पुनर्भुगतान व्यवस्था के संबंध में चर्चा कर सकते हैं।</p>
                                  <p>कृपया ध्यान दें कि यदि निर्धारित अवधि में EMI अथवा अन्य देय शुल्कों का भुगतान नहीं किया जाता है, तो प्रचलित नियमों एवं दिशानिर्देशों के अनुसार, आवेदक, गारंटर एवं सह-आवेदक के क्रेडिट ब्यूरो अभिलेखों में बकाया राशि की रिपोर्टिंग की जाएगी तथा ऋण समझौते एवं लागू कानूनों के अंतर्गत अन्य आवश्यक कार्रवाई की जा सकती है।</p>
                                  <p style={{ fontStyle: "italic" }}>यदि उक्त राशि का भुगतान पहले ही किया जा चुका है, तो कृपया इस पत्र को अनदेखा करें।</p>
                                </div>
                              )}

                              {/* Signature - Dynamic based on Agreement Number */}
                              <div style={{ marginTop: "40px" }}>
                                <p style={{ fontWeight: "bold" }}>For {getCompanyDetails(vitem?.AgreementNo).name}</p>
                                <div style={{ marginTop: "40px" }}>
                                  <p>____________________________</p>
                                  <p><strong>Manager/Authorized Signatory</strong></p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}




      </div>



     <Modal
                    open={openPayment}
                    onClose={handleClose}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                >
                    <div className='modal-custom rounded'>
                        <div className='modal-head'>
                            <h4 id="modal-title">Payment Document</h4>
                        </div>
    
                        <div className='modal-body'>
                            <div className='row mb-2 pb-1'>
                                <div className='col-1'>&nbsp;</div>
                                <div className='col-10 ps-0'>{viewModalInfo.note}</div>
                            </div>
                        </div>
                    </div>
                </Modal>

    </>
  );
});


function mapStateToProps(state) {
  return {
    getUserModuleData: state.getUserModuleData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(leadActions.default, reportActions.default, masterAction.default, leadBankStatementActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(LoanVersioning);
